/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as DashRouteImport } from "./routes/_dash";
import { Route as IndexRouteImport } from "./routes/index";
import { Route as AuthCapCodeMcpRouteImport } from "./routes/auth/cap-code-mcp";
import { Route as AuthCallbackRouteImport } from "./routes/auth/callback";
import { Route as DashYoutubeDownloadRouteImport } from "./routes/_dash/youtube-download";
import { Route as DashVideosRouteImport } from "./routes/_dash/videos";
import { Route as DashUsersRouteImport } from "./routes/_dash/users";
import { Route as DashStudioEditsRouteImport } from "./routes/_dash/studio-edits";
import { Route as DashSessionReplaysRouteImport } from "./routes/_dash/session-replays";
import { Route as DashSessionRouteImport } from "./routes/_dash/session";
import { Route as DashReleaseHistoryRouteImport } from "./routes/_dash/release-history";
import { Route as DashProjectsRouteImport } from "./routes/_dash/projects";
import { Route as DashProfileRouteImport } from "./routes/_dash/profile";
import { Route as DashOrganizationsRouteImport } from "./routes/_dash/organizations";
import { Route as DashModerationRouteImport } from "./routes/_dash/moderation";
import { Route as DashMcpRouteImport } from "./routes/_dash/mcp";
import { Route as DashLtvRouteImport } from "./routes/_dash/ltv";
import { Route as DashLinkedinSkillsRouteImport } from "./routes/_dash/linkedin-skills";
import { Route as DashJerboaEditorSessionRouteImport } from "./routes/_dash/jerboa-editor-session";
import { Route as DashJerboaCodecReportRouteImport } from "./routes/_dash/jerboa-codec-report";
import { Route as DashJerboaClientPreviewRouteImport } from "./routes/_dash/jerboa-client-preview";
import { Route as DashJerboaClientNetworkLoadRouteImport } from "./routes/_dash/jerboa-client-network-load";
import { Route as DashJerboaClientExportRouteImport } from "./routes/_dash/jerboa-client-export";
import { Route as DashJerboaClientErrorRouteImport } from "./routes/_dash/jerboa-client-error";
import { Route as DashJerboaRouteImport } from "./routes/_dash/jerboa";
import { Route as DashHumanEditingRequestsRouteImport } from "./routes/_dash/human-editing-requests";
import { Route as DashHomeRouteImport } from "./routes/_dash/home";
import { Route as DashFileUploadRouteImport } from "./routes/_dash/file-upload";
import { Route as DashEmployeeRouteImport } from "./routes/_dash/employee";
import { Route as DashCreditsRouteImport } from "./routes/_dash/credits";
import { Route as DashCreatorStylesRouteImport } from "./routes/_dash/creator-styles";
import { Route as DashCloudflareRedirectsRouteImport } from "./routes/_dash/cloudflare-redirects";
import { Route as DashCaptionTemplatesRouteImport } from "./routes/_dash/caption-templates";
import { Route as DashCapcodeRouteImport } from "./routes/_dash/capcode";
import { Route as DashBetaWaitlistRouteImport } from "./routes/_dash/beta-waitlist";
import { Route as DashBasecampStyleReviewsRouteImport } from "./routes/_dash/basecamp-style-reviews";
import { Route as DashBasecampRunInspectorRouteImport } from "./routes/_dash/basecamp-run-inspector";
import { Route as DashBasecampRouteImport } from "./routes/_dash/basecamp";
import { Route as DashAudioRouteImport } from "./routes/_dash/audio";
import { Route as DashAiEditsRouteImport } from "./routes/_dash/ai-edits";
import { Route as DashAiEditToolRouteImport } from "./routes/_dash/ai-edit-tool";
import { Route as DashAgaveRouteImport } from "./routes/_dash/agave";
import { Route as DashActorsRouteImport } from "./routes/_dash/actors";
import { Route as DashVideosIndexRouteImport } from "./routes/_dash/videos/index";
import { Route as DashUsersIndexRouteImport } from "./routes/_dash/users/index";
import { Route as DashStudioEditsIndexRouteImport } from "./routes/_dash/studio-edits/index";
import { Route as DashSessionReplaysIndexRouteImport } from "./routes/_dash/session-replays/index";
import { Route as DashProjectsIndexRouteImport } from "./routes/_dash/projects/index";
import { Route as DashOrganizationsIndexRouteImport } from "./routes/_dash/organizations/index";
import { Route as DashOrgByDefaultIndexRouteImport } from "./routes/_dash/org-by-default/index";
import { Route as DashModerationIndexRouteImport } from "./routes/_dash/moderation/index";
import { Route as DashMcpIndexRouteImport } from "./routes/_dash/mcp/index";
import { Route as DashJerboaEditorSessionIndexRouteImport } from "./routes/_dash/jerboa-editor-session/index";
import { Route as DashJerboaCodecReportIndexRouteImport } from "./routes/_dash/jerboa-codec-report/index";
import { Route as DashJerboaClientPreviewIndexRouteImport } from "./routes/_dash/jerboa-client-preview/index";
import { Route as DashJerboaClientNetworkLoadIndexRouteImport } from "./routes/_dash/jerboa-client-network-load/index";
import { Route as DashJerboaClientExportIndexRouteImport } from "./routes/_dash/jerboa-client-export/index";
import { Route as DashJerboaClientErrorIndexRouteImport } from "./routes/_dash/jerboa-client-error/index";
import { Route as DashCreditsIndexRouteImport } from "./routes/_dash/credits/index";
import { Route as DashCreatorStylesIndexRouteImport } from "./routes/_dash/creator-styles/index";
import { Route as DashCloudflareRedirectsIndexRouteImport } from "./routes/_dash/cloudflare-redirects/index";
import { Route as DashCaptionTemplatesIndexRouteImport } from "./routes/_dash/caption-templates/index";
import { Route as DashCapcodeIndexRouteImport } from "./routes/_dash/capcode/index";
import { Route as DashAudioIndexRouteImport } from "./routes/_dash/audio/index";
import { Route as DashAiEditsIndexRouteImport } from "./routes/_dash/ai-edits/index";
import { Route as DashAiEditToolIndexRouteImport } from "./routes/_dash/ai-edit-tool/index";
import { Route as DashActorsIndexRouteImport } from "./routes/_dash/actors/index";
import { Route as DashVideosEvalsRouteImport } from "./routes/_dash/videos/evals";
import { Route as DashVideosBookmarkedRouteImport } from "./routes/_dash/videos/bookmarked";
import { Route as DashUsersInternalTestAccountsRouteImport } from "./routes/_dash/users/internal-test-accounts";
import { Route as DashUsersInternalAccountsRouteImport } from "./routes/_dash/users/internal-accounts";
import { Route as DashSessionReplaysReplayIdRouteImport } from "./routes/_dash/session-replays/$replayId";
import { Route as DashReviewFeedbackFeedbackIdRouteImport } from "./routes/_dash/review-feedback/$feedbackId";
import { Route as DashProjectsTesseractRouteImport } from "./routes/_dash/projects/tesseract";
import { Route as DashProjectsSearchRouteImport } from "./routes/_dash/projects/search";
import { Route as DashProjectsChatsRouteImport } from "./routes/_dash/projects/chats";
import { Route as DashProjectsAnimationLibraryRouteImport } from "./routes/_dash/projects/animation-library";
import { Route as DashProjectsProjectIdRouteImport } from "./routes/_dash/projects/$projectId";
import { Route as DashLtvMetaSendAuditRouteImport } from "./routes/_dash/ltv/meta-send-audit";
import { Route as DashLtvAppsflyerSendAuditRouteImport } from "./routes/_dash/ltv/appsflyer-send-audit";
import { Route as DashJerboaRenderingResultsRouteImport } from "./routes/_dash/jerboa/rendering-results";
import { Route as DashJerboaAiEditFxShadowingRouteImport } from "./routes/_dash/jerboa/ai-edit-fx-shadowing";
import { Route as DashJerboaEditorSessionIdRouteImport } from "./routes/_dash/jerboa-editor-session/$id";
import { Route as DashJerboaCodecReportIdRouteImport } from "./routes/_dash/jerboa-codec-report/$id";
import { Route as DashJerboaClientPreviewIdRouteImport } from "./routes/_dash/jerboa-client-preview/$id";
import { Route as DashJerboaClientNetworkLoadIdRouteImport } from "./routes/_dash/jerboa-client-network-load/$id";
import { Route as DashJerboaClientExportIdRouteImport } from "./routes/_dash/jerboa-client-export/$id";
import { Route as DashJerboaClientErrorIdRouteImport } from "./routes/_dash/jerboa-client-error/$id";
import { Route as DashCreatorStylesStyleIdRouteImport } from "./routes/_dash/creator-styles/$styleId";
import { Route as DashCaptionTemplatesTemplateIdRouteImport } from "./routes/_dash/caption-templates/$templateId";
import { Route as DashCapcodeReviewFeedbackRouteImport } from "./routes/_dash/capcode/review-feedback";
import { Route as DashBasecampEvalsRouteImport } from "./routes/_dash/basecamp/evals";
import { Route as DashAiEditsPromptToVideoRouteImport } from "./routes/_dash/ai-edits/prompt-to-video";
import { Route as DashAiEditsLongToShortRouteImport } from "./routes/_dash/ai-edits/long-to-short";
import { Route as DashAiEditsEvalsRouteImport } from "./routes/_dash/ai-edits/evals";
import { Route as DashAiEditsCactusToolsRouteImport } from "./routes/_dash/ai-edits/cactus-tools";
import { Route as DashAiEditsAllRouteImport } from "./routes/_dash/ai-edits/all";
import { Route as DashAiEditsAgaveShadowsRouteImport } from "./routes/_dash/ai-edits/agave-shadows";
import { Route as DashAiEditsAgaveOperationsRouteImport } from "./routes/_dash/ai-edits/agave-operations";
import { Route as DashAiEditsAgaveOperationGraphRouteImport } from "./routes/_dash/ai-edits/agave-operation-graph";
import { Route as DashAiEditsOperationIdRouteImport } from "./routes/_dash/ai-edits/$operationId";
import { Route as DashVideosSegmentEvalIndexRouteImport } from "./routes/_dash/videos/segment-eval/index";
import { Route as DashVideosEvalsIndexRouteImport } from "./routes/_dash/videos/evals/index";
import { Route as DashJerboaRenderingResultsIndexRouteImport } from "./routes/_dash/jerboa/rendering-results/index";
import { Route as DashJerboaAiEditFxShadowingIndexRouteImport } from "./routes/_dash/jerboa/ai-edit-fx-shadowing/index";
import { Route as DashCloudflareRedirectsRemoveIndexRouteImport } from "./routes/_dash/cloudflare-redirects/remove/index";
import { Route as DashCapcodeReviewsIndexRouteImport } from "./routes/_dash/capcode/reviews/index";
import { Route as DashBasecampUserOutputsIndexRouteImport } from "./routes/_dash/basecamp/user-outputs/index";
import { Route as DashBasecampEvalsIndexRouteImport } from "./routes/_dash/basecamp/evals/index";
import { Route as DashAiEditsEvalsIndexRouteImport } from "./routes/_dash/ai-edits/evals/index";
import { Route as DashAiEditsCactusToolsIndexRouteImport } from "./routes/_dash/ai-edits/cactus-tools/index";
import { Route as DashVideosViewVideoIdRouteImport } from "./routes/_dash/videos/view/$videoId";
import { Route as DashVideosSegmentEvalResultsRouteImport } from "./routes/_dash/videos/segment-eval/results";
import { Route as DashVideosSegmentEvalAdminRouteImport } from "./routes/_dash/videos/segment-eval/admin";
import { Route as DashVideosEvalsTestIdRouteImport } from "./routes/_dash/videos/evals/$testId";
import { Route as DashUsersViewUserIdRouteImport } from "./routes/_dash/users/view/$userId";
import { Route as DashUsersUndeleteAccountUserIdRouteImport } from "./routes/_dash/users/undelete-account/$userId";
import { Route as DashUsersForceSignOutUserIdRouteImport } from "./routes/_dash/users/force-sign-out/$userId";
import { Route as DashUsersDeleteAccountUserIdRouteImport } from "./routes/_dash/users/delete-account/$userId";
import { Route as DashStudioEditsViewVideoIdRouteImport } from "./routes/_dash/studio-edits/view/$videoId";
import { Route as DashOrganizationsViewOrgIdRouteImport } from "./routes/_dash/organizations/view/$orgId";
import { Route as DashMcpSkillsSkillRouteImport } from "./routes/_dash/mcp/skills/$skill";
import { Route as DashLinkedinSkillsUsersUserIdRouteImport } from "./routes/_dash/linkedin-skills/users/$userId";
import { Route as DashJerboaRenderingResultsResultIdRouteImport } from "./routes/_dash/jerboa/rendering-results/$resultId";
import { Route as DashJerboaAiEditFxShadowingResultIdRouteImport } from "./routes/_dash/jerboa/ai-edit-fx-shadowing/$resultId";
import { Route as DashChargesUsersUserIdRouteImport } from "./routes/_dash/charges/users/$userId";
import { Route as DashChargesOrganizationsOrgIdRouteImport } from "./routes/_dash/charges/organizations/$orgId";
import { Route as DashCapcodeReviewsDocIdRouteImport } from "./routes/_dash/capcode/reviews/$docId";
import { Route as DashBasecampEvalsComparisonIdRouteImport } from "./routes/_dash/basecamp/evals/$comparisonId";
import { Route as DashAiEditsEvalsRunIdRouteImport } from "./routes/_dash/ai-edits/evals/$runId";
import { Route as DashAiEditsAgaveShadowRendersShadowRenderIdRouteImport } from "./routes/_dash/ai-edits/agave-shadow-renders/$shadowRenderId";
import { Route as DashAiEditToolSstShotStyleIdRouteImport } from "./routes/_dash/ai-edit-tool/sst/$shotStyleId";
import { Route as DashAiEditToolNewVstRouteImport } from "./routes/_dash/ai-edit-tool/new/vst";
import { Route as DashVideosEvalsDpoIndexRouteImport } from "./routes/_dash/videos/evals/dpo/index";
import { Route as DashVideosEvalsDpoReviewIndexRouteImport } from "./routes/_dash/videos/evals/dpo-review/index";
import { Route as DashVideosEvalsTestIdIndexRouteImport } from "./routes/_dash/videos/evals/$testId/index";
import { Route as DashVideosEvalsDpoTestIdRouteImport } from "./routes/_dash/videos/evals/dpo/$testId";
import { Route as DashVideosEvalsDpoReviewPanelIdRouteImport } from "./routes/_dash/videos/evals/dpo-review/$panelId";
import { Route as DashVideosEvalsTestIdResultsRouteImport } from "./routes/_dash/videos/evals/$testId/results";
import { Route as DashVideosEvalsTestIdRankRouteImport } from "./routes/_dash/videos/evals/$testId/rank";
import { Route as DashAiEditsEvalsPairwiseComparisonIdRouteImport } from "./routes/_dash/ai-edits/evals/pairwise/$comparisonId";
import { Route as DashAiEditsEvalsComparisonsComparisonIdRouteImport } from "./routes/_dash/ai-edits/evals/comparisons/$comparisonId";
import { Route as DashAiEditsCactusToolsWorkflowIdentifierWorkflowRunIdRouteImport } from "./routes/_dash/ai-edits/cactus-tools/$workflowIdentifier/$workflowRunId";
import { Route as DashAiEditToolNewSstVideoStyleIdRouteImport } from "./routes/_dash/ai-edit-tool/new/sst/$videoStyleId";

const DashRoute = DashRouteImport.update({
  id: "/_dash",
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthCapCodeMcpRoute = AuthCapCodeMcpRouteImport.update({
  id: "/auth/cap-code-mcp",
  path: "/auth/cap-code-mcp",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: "/auth/callback",
  path: "/auth/callback",
  getParentRoute: () => rootRouteImport,
} as any);
const DashYoutubeDownloadRoute = DashYoutubeDownloadRouteImport.update({
  id: "/youtube-download",
  path: "/youtube-download",
  getParentRoute: () => DashRoute,
} as any);
const DashVideosRoute = DashVideosRouteImport.update({
  id: "/videos",
  path: "/videos",
  getParentRoute: () => DashRoute,
} as any);
const DashUsersRoute = DashUsersRouteImport.update({
  id: "/users",
  path: "/users",
  getParentRoute: () => DashRoute,
} as any);
const DashStudioEditsRoute = DashStudioEditsRouteImport.update({
  id: "/studio-edits",
  path: "/studio-edits",
  getParentRoute: () => DashRoute,
} as any);
const DashSessionReplaysRoute = DashSessionReplaysRouteImport.update({
  id: "/session-replays",
  path: "/session-replays",
  getParentRoute: () => DashRoute,
} as any);
const DashSessionRoute = DashSessionRouteImport.update({
  id: "/session",
  path: "/session",
  getParentRoute: () => DashRoute,
} as any);
const DashReleaseHistoryRoute = DashReleaseHistoryRouteImport.update({
  id: "/release-history",
  path: "/release-history",
  getParentRoute: () => DashRoute,
} as any);
const DashProjectsRoute = DashProjectsRouteImport.update({
  id: "/projects",
  path: "/projects",
  getParentRoute: () => DashRoute,
} as any);
const DashProfileRoute = DashProfileRouteImport.update({
  id: "/profile",
  path: "/profile",
  getParentRoute: () => DashRoute,
} as any);
const DashOrganizationsRoute = DashOrganizationsRouteImport.update({
  id: "/organizations",
  path: "/organizations",
  getParentRoute: () => DashRoute,
} as any);
const DashModerationRoute = DashModerationRouteImport.update({
  id: "/moderation",
  path: "/moderation",
  getParentRoute: () => DashRoute,
} as any);
const DashMcpRoute = DashMcpRouteImport.update({
  id: "/mcp",
  path: "/mcp",
  getParentRoute: () => DashRoute,
} as any);
const DashLtvRoute = DashLtvRouteImport.update({
  id: "/ltv",
  path: "/ltv",
  getParentRoute: () => DashRoute,
} as any);
const DashLinkedinSkillsRoute = DashLinkedinSkillsRouteImport.update({
  id: "/linkedin-skills",
  path: "/linkedin-skills",
  getParentRoute: () => DashRoute,
} as any);
const DashJerboaEditorSessionRoute = DashJerboaEditorSessionRouteImport.update({
  id: "/jerboa-editor-session",
  path: "/jerboa-editor-session",
  getParentRoute: () => DashRoute,
} as any);
const DashJerboaCodecReportRoute = DashJerboaCodecReportRouteImport.update({
  id: "/jerboa-codec-report",
  path: "/jerboa-codec-report",
  getParentRoute: () => DashRoute,
} as any);
const DashJerboaClientPreviewRoute = DashJerboaClientPreviewRouteImport.update({
  id: "/jerboa-client-preview",
  path: "/jerboa-client-preview",
  getParentRoute: () => DashRoute,
} as any);
const DashJerboaClientNetworkLoadRoute =
  DashJerboaClientNetworkLoadRouteImport.update({
    id: "/jerboa-client-network-load",
    path: "/jerboa-client-network-load",
    getParentRoute: () => DashRoute,
  } as any);
const DashJerboaClientExportRoute = DashJerboaClientExportRouteImport.update({
  id: "/jerboa-client-export",
  path: "/jerboa-client-export",
  getParentRoute: () => DashRoute,
} as any);
const DashJerboaClientErrorRoute = DashJerboaClientErrorRouteImport.update({
  id: "/jerboa-client-error",
  path: "/jerboa-client-error",
  getParentRoute: () => DashRoute,
} as any);
const DashJerboaRoute = DashJerboaRouteImport.update({
  id: "/jerboa",
  path: "/jerboa",
  getParentRoute: () => DashRoute,
} as any);
const DashHumanEditingRequestsRoute =
  DashHumanEditingRequestsRouteImport.update({
    id: "/human-editing-requests",
    path: "/human-editing-requests",
    getParentRoute: () => DashRoute,
  } as any);
const DashHomeRoute = DashHomeRouteImport.update({
  id: "/home",
  path: "/home",
  getParentRoute: () => DashRoute,
} as any);
const DashFileUploadRoute = DashFileUploadRouteImport.update({
  id: "/file-upload",
  path: "/file-upload",
  getParentRoute: () => DashRoute,
} as any);
const DashEmployeeRoute = DashEmployeeRouteImport.update({
  id: "/employee",
  path: "/employee",
  getParentRoute: () => DashRoute,
} as any);
const DashCreditsRoute = DashCreditsRouteImport.update({
  id: "/credits",
  path: "/credits",
  getParentRoute: () => DashRoute,
} as any);
const DashCreatorStylesRoute = DashCreatorStylesRouteImport.update({
  id: "/creator-styles",
  path: "/creator-styles",
  getParentRoute: () => DashRoute,
} as any);
const DashCloudflareRedirectsRoute = DashCloudflareRedirectsRouteImport.update({
  id: "/cloudflare-redirects",
  path: "/cloudflare-redirects",
  getParentRoute: () => DashRoute,
} as any);
const DashCaptionTemplatesRoute = DashCaptionTemplatesRouteImport.update({
  id: "/caption-templates",
  path: "/caption-templates",
  getParentRoute: () => DashRoute,
} as any);
const DashCapcodeRoute = DashCapcodeRouteImport.update({
  id: "/capcode",
  path: "/capcode",
  getParentRoute: () => DashRoute,
} as any);
const DashBetaWaitlistRoute = DashBetaWaitlistRouteImport.update({
  id: "/beta-waitlist",
  path: "/beta-waitlist",
  getParentRoute: () => DashRoute,
} as any);
const DashBasecampStyleReviewsRoute =
  DashBasecampStyleReviewsRouteImport.update({
    id: "/basecamp-style-reviews",
    path: "/basecamp-style-reviews",
    getParentRoute: () => DashRoute,
  } as any);
const DashBasecampRunInspectorRoute =
  DashBasecampRunInspectorRouteImport.update({
    id: "/basecamp-run-inspector",
    path: "/basecamp-run-inspector",
    getParentRoute: () => DashRoute,
  } as any);
const DashBasecampRoute = DashBasecampRouteImport.update({
  id: "/basecamp",
  path: "/basecamp",
  getParentRoute: () => DashRoute,
} as any);
const DashAudioRoute = DashAudioRouteImport.update({
  id: "/audio",
  path: "/audio",
  getParentRoute: () => DashRoute,
} as any);
const DashAiEditsRoute = DashAiEditsRouteImport.update({
  id: "/ai-edits",
  path: "/ai-edits",
  getParentRoute: () => DashRoute,
} as any);
const DashAiEditToolRoute = DashAiEditToolRouteImport.update({
  id: "/ai-edit-tool",
  path: "/ai-edit-tool",
  getParentRoute: () => DashRoute,
} as any);
const DashAgaveRoute = DashAgaveRouteImport.update({
  id: "/agave",
  path: "/agave",
  getParentRoute: () => DashRoute,
} as any);
const DashActorsRoute = DashActorsRouteImport.update({
  id: "/actors",
  path: "/actors",
  getParentRoute: () => DashRoute,
} as any);
const DashVideosIndexRoute = DashVideosIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => DashVideosRoute,
} as any);
const DashUsersIndexRoute = DashUsersIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => DashUsersRoute,
} as any);
const DashStudioEditsIndexRoute = DashStudioEditsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => DashStudioEditsRoute,
} as any);
const DashSessionReplaysIndexRoute = DashSessionReplaysIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => DashSessionReplaysRoute,
} as any);
const DashProjectsIndexRoute = DashProjectsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => DashProjectsRoute,
} as any);
const DashOrganizationsIndexRoute = DashOrganizationsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => DashOrganizationsRoute,
} as any);
const DashOrgByDefaultIndexRoute = DashOrgByDefaultIndexRouteImport.update({
  id: "/org-by-default/",
  path: "/org-by-default/",
  getParentRoute: () => DashRoute,
} as any);
const DashModerationIndexRoute = DashModerationIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => DashModerationRoute,
} as any);
const DashMcpIndexRoute = DashMcpIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => DashMcpRoute,
} as any);
const DashJerboaEditorSessionIndexRoute =
  DashJerboaEditorSessionIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => DashJerboaEditorSessionRoute,
  } as any);
const DashJerboaCodecReportIndexRoute =
  DashJerboaCodecReportIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => DashJerboaCodecReportRoute,
  } as any);
const DashJerboaClientPreviewIndexRoute =
  DashJerboaClientPreviewIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => DashJerboaClientPreviewRoute,
  } as any);
const DashJerboaClientNetworkLoadIndexRoute =
  DashJerboaClientNetworkLoadIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => DashJerboaClientNetworkLoadRoute,
  } as any);
const DashJerboaClientExportIndexRoute =
  DashJerboaClientExportIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => DashJerboaClientExportRoute,
  } as any);
const DashJerboaClientErrorIndexRoute =
  DashJerboaClientErrorIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => DashJerboaClientErrorRoute,
  } as any);
const DashCreditsIndexRoute = DashCreditsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => DashCreditsRoute,
} as any);
const DashCreatorStylesIndexRoute = DashCreatorStylesIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => DashCreatorStylesRoute,
} as any);
const DashCloudflareRedirectsIndexRoute =
  DashCloudflareRedirectsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => DashCloudflareRedirectsRoute,
  } as any);
const DashCaptionTemplatesIndexRoute =
  DashCaptionTemplatesIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => DashCaptionTemplatesRoute,
  } as any);
const DashCapcodeIndexRoute = DashCapcodeIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => DashCapcodeRoute,
} as any);
const DashAudioIndexRoute = DashAudioIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => DashAudioRoute,
} as any);
const DashAiEditsIndexRoute = DashAiEditsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => DashAiEditsRoute,
} as any);
const DashAiEditToolIndexRoute = DashAiEditToolIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => DashAiEditToolRoute,
} as any);
const DashActorsIndexRoute = DashActorsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => DashActorsRoute,
} as any);
const DashVideosEvalsRoute = DashVideosEvalsRouteImport.update({
  id: "/evals",
  path: "/evals",
  getParentRoute: () => DashVideosRoute,
} as any);
const DashVideosBookmarkedRoute = DashVideosBookmarkedRouteImport.update({
  id: "/bookmarked",
  path: "/bookmarked",
  getParentRoute: () => DashVideosRoute,
} as any);
const DashUsersInternalTestAccountsRoute =
  DashUsersInternalTestAccountsRouteImport.update({
    id: "/internal-test-accounts",
    path: "/internal-test-accounts",
    getParentRoute: () => DashUsersRoute,
  } as any);
const DashUsersInternalAccountsRoute =
  DashUsersInternalAccountsRouteImport.update({
    id: "/internal-accounts",
    path: "/internal-accounts",
    getParentRoute: () => DashUsersRoute,
  } as any);
const DashSessionReplaysReplayIdRoute =
  DashSessionReplaysReplayIdRouteImport.update({
    id: "/$replayId",
    path: "/$replayId",
    getParentRoute: () => DashSessionReplaysRoute,
  } as any);
const DashReviewFeedbackFeedbackIdRoute =
  DashReviewFeedbackFeedbackIdRouteImport.update({
    id: "/review-feedback/$feedbackId",
    path: "/review-feedback/$feedbackId",
    getParentRoute: () => DashRoute,
  } as any);
const DashProjectsTesseractRoute = DashProjectsTesseractRouteImport.update({
  id: "/tesseract",
  path: "/tesseract",
  getParentRoute: () => DashProjectsRoute,
} as any);
const DashProjectsSearchRoute = DashProjectsSearchRouteImport.update({
  id: "/search",
  path: "/search",
  getParentRoute: () => DashProjectsRoute,
} as any);
const DashProjectsChatsRoute = DashProjectsChatsRouteImport.update({
  id: "/chats",
  path: "/chats",
  getParentRoute: () => DashProjectsRoute,
} as any);
const DashProjectsAnimationLibraryRoute =
  DashProjectsAnimationLibraryRouteImport.update({
    id: "/animation-library",
    path: "/animation-library",
    getParentRoute: () => DashProjectsRoute,
  } as any);
const DashProjectsProjectIdRoute = DashProjectsProjectIdRouteImport.update({
  id: "/$projectId",
  path: "/$projectId",
  getParentRoute: () => DashProjectsRoute,
} as any);
const DashLtvMetaSendAuditRoute = DashLtvMetaSendAuditRouteImport.update({
  id: "/meta-send-audit",
  path: "/meta-send-audit",
  getParentRoute: () => DashLtvRoute,
} as any);
const DashLtvAppsflyerSendAuditRoute =
  DashLtvAppsflyerSendAuditRouteImport.update({
    id: "/appsflyer-send-audit",
    path: "/appsflyer-send-audit",
    getParentRoute: () => DashLtvRoute,
  } as any);
const DashJerboaRenderingResultsRoute =
  DashJerboaRenderingResultsRouteImport.update({
    id: "/rendering-results",
    path: "/rendering-results",
    getParentRoute: () => DashJerboaRoute,
  } as any);
const DashJerboaAiEditFxShadowingRoute =
  DashJerboaAiEditFxShadowingRouteImport.update({
    id: "/ai-edit-fx-shadowing",
    path: "/ai-edit-fx-shadowing",
    getParentRoute: () => DashJerboaRoute,
  } as any);
const DashJerboaEditorSessionIdRoute =
  DashJerboaEditorSessionIdRouteImport.update({
    id: "/$id",
    path: "/$id",
    getParentRoute: () => DashJerboaEditorSessionRoute,
  } as any);
const DashJerboaCodecReportIdRoute = DashJerboaCodecReportIdRouteImport.update({
  id: "/$id",
  path: "/$id",
  getParentRoute: () => DashJerboaCodecReportRoute,
} as any);
const DashJerboaClientPreviewIdRoute =
  DashJerboaClientPreviewIdRouteImport.update({
    id: "/$id",
    path: "/$id",
    getParentRoute: () => DashJerboaClientPreviewRoute,
  } as any);
const DashJerboaClientNetworkLoadIdRoute =
  DashJerboaClientNetworkLoadIdRouteImport.update({
    id: "/$id",
    path: "/$id",
    getParentRoute: () => DashJerboaClientNetworkLoadRoute,
  } as any);
const DashJerboaClientExportIdRoute =
  DashJerboaClientExportIdRouteImport.update({
    id: "/$id",
    path: "/$id",
    getParentRoute: () => DashJerboaClientExportRoute,
  } as any);
const DashJerboaClientErrorIdRoute = DashJerboaClientErrorIdRouteImport.update({
  id: "/$id",
  path: "/$id",
  getParentRoute: () => DashJerboaClientErrorRoute,
} as any);
const DashCreatorStylesStyleIdRoute =
  DashCreatorStylesStyleIdRouteImport.update({
    id: "/$styleId",
    path: "/$styleId",
    getParentRoute: () => DashCreatorStylesRoute,
  } as any);
const DashCaptionTemplatesTemplateIdRoute =
  DashCaptionTemplatesTemplateIdRouteImport.update({
    id: "/$templateId",
    path: "/$templateId",
    getParentRoute: () => DashCaptionTemplatesRoute,
  } as any);
const DashCapcodeReviewFeedbackRoute =
  DashCapcodeReviewFeedbackRouteImport.update({
    id: "/review-feedback",
    path: "/review-feedback",
    getParentRoute: () => DashCapcodeRoute,
  } as any);
const DashBasecampEvalsRoute = DashBasecampEvalsRouteImport.update({
  id: "/evals",
  path: "/evals",
  getParentRoute: () => DashBasecampRoute,
} as any);
const DashAiEditsPromptToVideoRoute =
  DashAiEditsPromptToVideoRouteImport.update({
    id: "/prompt-to-video",
    path: "/prompt-to-video",
    getParentRoute: () => DashAiEditsRoute,
  } as any);
const DashAiEditsLongToShortRoute = DashAiEditsLongToShortRouteImport.update({
  id: "/long-to-short",
  path: "/long-to-short",
  getParentRoute: () => DashAiEditsRoute,
} as any);
const DashAiEditsEvalsRoute = DashAiEditsEvalsRouteImport.update({
  id: "/evals",
  path: "/evals",
  getParentRoute: () => DashAiEditsRoute,
} as any);
const DashAiEditsCactusToolsRoute = DashAiEditsCactusToolsRouteImport.update({
  id: "/cactus-tools",
  path: "/cactus-tools",
  getParentRoute: () => DashAiEditsRoute,
} as any);
const DashAiEditsAllRoute = DashAiEditsAllRouteImport.update({
  id: "/all",
  path: "/all",
  getParentRoute: () => DashAiEditsRoute,
} as any);
const DashAiEditsAgaveShadowsRoute = DashAiEditsAgaveShadowsRouteImport.update({
  id: "/agave-shadows",
  path: "/agave-shadows",
  getParentRoute: () => DashAiEditsRoute,
} as any);
const DashAiEditsAgaveOperationsRoute =
  DashAiEditsAgaveOperationsRouteImport.update({
    id: "/agave-operations",
    path: "/agave-operations",
    getParentRoute: () => DashAiEditsRoute,
  } as any);
const DashAiEditsAgaveOperationGraphRoute =
  DashAiEditsAgaveOperationGraphRouteImport.update({
    id: "/agave-operation-graph",
    path: "/agave-operation-graph",
    getParentRoute: () => DashAiEditsRoute,
  } as any);
const DashAiEditsOperationIdRoute = DashAiEditsOperationIdRouteImport.update({
  id: "/$operationId",
  path: "/$operationId",
  getParentRoute: () => DashAiEditsRoute,
} as any);
const DashVideosSegmentEvalIndexRoute =
  DashVideosSegmentEvalIndexRouteImport.update({
    id: "/segment-eval/",
    path: "/segment-eval/",
    getParentRoute: () => DashVideosRoute,
  } as any);
const DashVideosEvalsIndexRoute = DashVideosEvalsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => DashVideosEvalsRoute,
} as any);
const DashJerboaRenderingResultsIndexRoute =
  DashJerboaRenderingResultsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => DashJerboaRenderingResultsRoute,
  } as any);
const DashJerboaAiEditFxShadowingIndexRoute =
  DashJerboaAiEditFxShadowingIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => DashJerboaAiEditFxShadowingRoute,
  } as any);
const DashCloudflareRedirectsRemoveIndexRoute =
  DashCloudflareRedirectsRemoveIndexRouteImport.update({
    id: "/remove/",
    path: "/remove/",
    getParentRoute: () => DashCloudflareRedirectsRoute,
  } as any);
const DashCapcodeReviewsIndexRoute = DashCapcodeReviewsIndexRouteImport.update({
  id: "/reviews/",
  path: "/reviews/",
  getParentRoute: () => DashCapcodeRoute,
} as any);
const DashBasecampUserOutputsIndexRoute =
  DashBasecampUserOutputsIndexRouteImport.update({
    id: "/user-outputs/",
    path: "/user-outputs/",
    getParentRoute: () => DashBasecampRoute,
  } as any);
const DashBasecampEvalsIndexRoute = DashBasecampEvalsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => DashBasecampEvalsRoute,
} as any);
const DashAiEditsEvalsIndexRoute = DashAiEditsEvalsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => DashAiEditsEvalsRoute,
} as any);
const DashAiEditsCactusToolsIndexRoute =
  DashAiEditsCactusToolsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => DashAiEditsCactusToolsRoute,
  } as any);
const DashVideosViewVideoIdRoute = DashVideosViewVideoIdRouteImport.update({
  id: "/view/$videoId",
  path: "/view/$videoId",
  getParentRoute: () => DashVideosRoute,
} as any);
const DashVideosSegmentEvalResultsRoute =
  DashVideosSegmentEvalResultsRouteImport.update({
    id: "/segment-eval/results",
    path: "/segment-eval/results",
    getParentRoute: () => DashVideosRoute,
  } as any);
const DashVideosSegmentEvalAdminRoute =
  DashVideosSegmentEvalAdminRouteImport.update({
    id: "/segment-eval/admin",
    path: "/segment-eval/admin",
    getParentRoute: () => DashVideosRoute,
  } as any);
const DashVideosEvalsTestIdRoute = DashVideosEvalsTestIdRouteImport.update({
  id: "/$testId",
  path: "/$testId",
  getParentRoute: () => DashVideosEvalsRoute,
} as any);
const DashUsersViewUserIdRoute = DashUsersViewUserIdRouteImport.update({
  id: "/view/$userId",
  path: "/view/$userId",
  getParentRoute: () => DashUsersRoute,
} as any);
const DashUsersUndeleteAccountUserIdRoute =
  DashUsersUndeleteAccountUserIdRouteImport.update({
    id: "/undelete-account/$userId",
    path: "/undelete-account/$userId",
    getParentRoute: () => DashUsersRoute,
  } as any);
const DashUsersForceSignOutUserIdRoute =
  DashUsersForceSignOutUserIdRouteImport.update({
    id: "/force-sign-out/$userId",
    path: "/force-sign-out/$userId",
    getParentRoute: () => DashUsersRoute,
  } as any);
const DashUsersDeleteAccountUserIdRoute =
  DashUsersDeleteAccountUserIdRouteImport.update({
    id: "/delete-account/$userId",
    path: "/delete-account/$userId",
    getParentRoute: () => DashUsersRoute,
  } as any);
const DashStudioEditsViewVideoIdRoute =
  DashStudioEditsViewVideoIdRouteImport.update({
    id: "/view/$videoId",
    path: "/view/$videoId",
    getParentRoute: () => DashStudioEditsRoute,
  } as any);
const DashOrganizationsViewOrgIdRoute =
  DashOrganizationsViewOrgIdRouteImport.update({
    id: "/view/$orgId",
    path: "/view/$orgId",
    getParentRoute: () => DashOrganizationsRoute,
  } as any);
const DashMcpSkillsSkillRoute = DashMcpSkillsSkillRouteImport.update({
  id: "/skills/$skill",
  path: "/skills/$skill",
  getParentRoute: () => DashMcpRoute,
} as any);
const DashLinkedinSkillsUsersUserIdRoute =
  DashLinkedinSkillsUsersUserIdRouteImport.update({
    id: "/users/$userId",
    path: "/users/$userId",
    getParentRoute: () => DashLinkedinSkillsRoute,
  } as any);
const DashJerboaRenderingResultsResultIdRoute =
  DashJerboaRenderingResultsResultIdRouteImport.update({
    id: "/$resultId",
    path: "/$resultId",
    getParentRoute: () => DashJerboaRenderingResultsRoute,
  } as any);
const DashJerboaAiEditFxShadowingResultIdRoute =
  DashJerboaAiEditFxShadowingResultIdRouteImport.update({
    id: "/$resultId",
    path: "/$resultId",
    getParentRoute: () => DashJerboaAiEditFxShadowingRoute,
  } as any);
const DashChargesUsersUserIdRoute = DashChargesUsersUserIdRouteImport.update({
  id: "/charges/users/$userId",
  path: "/charges/users/$userId",
  getParentRoute: () => DashRoute,
} as any);
const DashChargesOrganizationsOrgIdRoute =
  DashChargesOrganizationsOrgIdRouteImport.update({
    id: "/charges/organizations/$orgId",
    path: "/charges/organizations/$orgId",
    getParentRoute: () => DashRoute,
  } as any);
const DashCapcodeReviewsDocIdRoute = DashCapcodeReviewsDocIdRouteImport.update({
  id: "/reviews/$docId",
  path: "/reviews/$docId",
  getParentRoute: () => DashCapcodeRoute,
} as any);
const DashBasecampEvalsComparisonIdRoute =
  DashBasecampEvalsComparisonIdRouteImport.update({
    id: "/$comparisonId",
    path: "/$comparisonId",
    getParentRoute: () => DashBasecampEvalsRoute,
  } as any);
const DashAiEditsEvalsRunIdRoute = DashAiEditsEvalsRunIdRouteImport.update({
  id: "/$runId",
  path: "/$runId",
  getParentRoute: () => DashAiEditsEvalsRoute,
} as any);
const DashAiEditsAgaveShadowRendersShadowRenderIdRoute =
  DashAiEditsAgaveShadowRendersShadowRenderIdRouteImport.update({
    id: "/agave-shadow-renders/$shadowRenderId",
    path: "/agave-shadow-renders/$shadowRenderId",
    getParentRoute: () => DashAiEditsRoute,
  } as any);
const DashAiEditToolSstShotStyleIdRoute =
  DashAiEditToolSstShotStyleIdRouteImport.update({
    id: "/sst/$shotStyleId",
    path: "/sst/$shotStyleId",
    getParentRoute: () => DashAiEditToolRoute,
  } as any);
const DashAiEditToolNewVstRoute = DashAiEditToolNewVstRouteImport.update({
  id: "/new/vst",
  path: "/new/vst",
  getParentRoute: () => DashAiEditToolRoute,
} as any);
const DashVideosEvalsDpoIndexRoute = DashVideosEvalsDpoIndexRouteImport.update({
  id: "/dpo/",
  path: "/dpo/",
  getParentRoute: () => DashVideosEvalsRoute,
} as any);
const DashVideosEvalsDpoReviewIndexRoute =
  DashVideosEvalsDpoReviewIndexRouteImport.update({
    id: "/dpo-review/",
    path: "/dpo-review/",
    getParentRoute: () => DashVideosEvalsRoute,
  } as any);
const DashVideosEvalsTestIdIndexRoute =
  DashVideosEvalsTestIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => DashVideosEvalsTestIdRoute,
  } as any);
const DashVideosEvalsDpoTestIdRoute =
  DashVideosEvalsDpoTestIdRouteImport.update({
    id: "/dpo/$testId",
    path: "/dpo/$testId",
    getParentRoute: () => DashVideosEvalsRoute,
  } as any);
const DashVideosEvalsDpoReviewPanelIdRoute =
  DashVideosEvalsDpoReviewPanelIdRouteImport.update({
    id: "/dpo-review/$panelId",
    path: "/dpo-review/$panelId",
    getParentRoute: () => DashVideosEvalsRoute,
  } as any);
const DashVideosEvalsTestIdResultsRoute =
  DashVideosEvalsTestIdResultsRouteImport.update({
    id: "/results",
    path: "/results",
    getParentRoute: () => DashVideosEvalsTestIdRoute,
  } as any);
const DashVideosEvalsTestIdRankRoute =
  DashVideosEvalsTestIdRankRouteImport.update({
    id: "/rank",
    path: "/rank",
    getParentRoute: () => DashVideosEvalsTestIdRoute,
  } as any);
const DashAiEditsEvalsPairwiseComparisonIdRoute =
  DashAiEditsEvalsPairwiseComparisonIdRouteImport.update({
    id: "/pairwise/$comparisonId",
    path: "/pairwise/$comparisonId",
    getParentRoute: () => DashAiEditsEvalsRoute,
  } as any);
const DashAiEditsEvalsComparisonsComparisonIdRoute =
  DashAiEditsEvalsComparisonsComparisonIdRouteImport.update({
    id: "/comparisons/$comparisonId",
    path: "/comparisons/$comparisonId",
    getParentRoute: () => DashAiEditsEvalsRoute,
  } as any);
const DashAiEditsCactusToolsWorkflowIdentifierWorkflowRunIdRoute =
  DashAiEditsCactusToolsWorkflowIdentifierWorkflowRunIdRouteImport.update({
    id: "/$workflowIdentifier/$workflowRunId",
    path: "/$workflowIdentifier/$workflowRunId",
    getParentRoute: () => DashAiEditsCactusToolsRoute,
  } as any);
const DashAiEditToolNewSstVideoStyleIdRoute =
  DashAiEditToolNewSstVideoStyleIdRouteImport.update({
    id: "/new/sst/$videoStyleId",
    path: "/new/sst/$videoStyleId",
    getParentRoute: () => DashAiEditToolRoute,
  } as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/actors": typeof DashActorsRouteWithChildren;
  "/agave": typeof DashAgaveRoute;
  "/ai-edit-tool": typeof DashAiEditToolRouteWithChildren;
  "/ai-edits": typeof DashAiEditsRouteWithChildren;
  "/audio": typeof DashAudioRouteWithChildren;
  "/basecamp": typeof DashBasecampRouteWithChildren;
  "/basecamp-run-inspector": typeof DashBasecampRunInspectorRoute;
  "/basecamp-style-reviews": typeof DashBasecampStyleReviewsRoute;
  "/beta-waitlist": typeof DashBetaWaitlistRoute;
  "/capcode": typeof DashCapcodeRouteWithChildren;
  "/caption-templates": typeof DashCaptionTemplatesRouteWithChildren;
  "/cloudflare-redirects": typeof DashCloudflareRedirectsRouteWithChildren;
  "/creator-styles": typeof DashCreatorStylesRouteWithChildren;
  "/credits": typeof DashCreditsRouteWithChildren;
  "/employee": typeof DashEmployeeRoute;
  "/file-upload": typeof DashFileUploadRoute;
  "/home": typeof DashHomeRoute;
  "/human-editing-requests": typeof DashHumanEditingRequestsRoute;
  "/jerboa": typeof DashJerboaRouteWithChildren;
  "/jerboa-client-error": typeof DashJerboaClientErrorRouteWithChildren;
  "/jerboa-client-export": typeof DashJerboaClientExportRouteWithChildren;
  "/jerboa-client-network-load": typeof DashJerboaClientNetworkLoadRouteWithChildren;
  "/jerboa-client-preview": typeof DashJerboaClientPreviewRouteWithChildren;
  "/jerboa-codec-report": typeof DashJerboaCodecReportRouteWithChildren;
  "/jerboa-editor-session": typeof DashJerboaEditorSessionRouteWithChildren;
  "/linkedin-skills": typeof DashLinkedinSkillsRouteWithChildren;
  "/ltv": typeof DashLtvRouteWithChildren;
  "/mcp": typeof DashMcpRouteWithChildren;
  "/moderation": typeof DashModerationRouteWithChildren;
  "/organizations": typeof DashOrganizationsRouteWithChildren;
  "/profile": typeof DashProfileRoute;
  "/projects": typeof DashProjectsRouteWithChildren;
  "/release-history": typeof DashReleaseHistoryRoute;
  "/session": typeof DashSessionRoute;
  "/session-replays": typeof DashSessionReplaysRouteWithChildren;
  "/studio-edits": typeof DashStudioEditsRouteWithChildren;
  "/users": typeof DashUsersRouteWithChildren;
  "/videos": typeof DashVideosRouteWithChildren;
  "/youtube-download": typeof DashYoutubeDownloadRoute;
  "/auth/callback": typeof AuthCallbackRoute;
  "/auth/cap-code-mcp": typeof AuthCapCodeMcpRoute;
  "/ai-edits/$operationId": typeof DashAiEditsOperationIdRoute;
  "/ai-edits/agave-operation-graph": typeof DashAiEditsAgaveOperationGraphRoute;
  "/ai-edits/agave-operations": typeof DashAiEditsAgaveOperationsRoute;
  "/ai-edits/agave-shadows": typeof DashAiEditsAgaveShadowsRoute;
  "/ai-edits/all": typeof DashAiEditsAllRoute;
  "/ai-edits/cactus-tools": typeof DashAiEditsCactusToolsRouteWithChildren;
  "/ai-edits/evals": typeof DashAiEditsEvalsRouteWithChildren;
  "/ai-edits/long-to-short": typeof DashAiEditsLongToShortRoute;
  "/ai-edits/prompt-to-video": typeof DashAiEditsPromptToVideoRoute;
  "/basecamp/evals": typeof DashBasecampEvalsRouteWithChildren;
  "/capcode/review-feedback": typeof DashCapcodeReviewFeedbackRoute;
  "/caption-templates/$templateId": typeof DashCaptionTemplatesTemplateIdRoute;
  "/creator-styles/$styleId": typeof DashCreatorStylesStyleIdRoute;
  "/jerboa-client-error/$id": typeof DashJerboaClientErrorIdRoute;
  "/jerboa-client-export/$id": typeof DashJerboaClientExportIdRoute;
  "/jerboa-client-network-load/$id": typeof DashJerboaClientNetworkLoadIdRoute;
  "/jerboa-client-preview/$id": typeof DashJerboaClientPreviewIdRoute;
  "/jerboa-codec-report/$id": typeof DashJerboaCodecReportIdRoute;
  "/jerboa-editor-session/$id": typeof DashJerboaEditorSessionIdRoute;
  "/jerboa/ai-edit-fx-shadowing": typeof DashJerboaAiEditFxShadowingRouteWithChildren;
  "/jerboa/rendering-results": typeof DashJerboaRenderingResultsRouteWithChildren;
  "/ltv/appsflyer-send-audit": typeof DashLtvAppsflyerSendAuditRoute;
  "/ltv/meta-send-audit": typeof DashLtvMetaSendAuditRoute;
  "/projects/$projectId": typeof DashProjectsProjectIdRoute;
  "/projects/animation-library": typeof DashProjectsAnimationLibraryRoute;
  "/projects/chats": typeof DashProjectsChatsRoute;
  "/projects/search": typeof DashProjectsSearchRoute;
  "/projects/tesseract": typeof DashProjectsTesseractRoute;
  "/review-feedback/$feedbackId": typeof DashReviewFeedbackFeedbackIdRoute;
  "/session-replays/$replayId": typeof DashSessionReplaysReplayIdRoute;
  "/users/internal-accounts": typeof DashUsersInternalAccountsRoute;
  "/users/internal-test-accounts": typeof DashUsersInternalTestAccountsRoute;
  "/videos/bookmarked": typeof DashVideosBookmarkedRoute;
  "/videos/evals": typeof DashVideosEvalsRouteWithChildren;
  "/actors/": typeof DashActorsIndexRoute;
  "/ai-edit-tool/": typeof DashAiEditToolIndexRoute;
  "/ai-edits/": typeof DashAiEditsIndexRoute;
  "/audio/": typeof DashAudioIndexRoute;
  "/capcode/": typeof DashCapcodeIndexRoute;
  "/caption-templates/": typeof DashCaptionTemplatesIndexRoute;
  "/cloudflare-redirects/": typeof DashCloudflareRedirectsIndexRoute;
  "/creator-styles/": typeof DashCreatorStylesIndexRoute;
  "/credits/": typeof DashCreditsIndexRoute;
  "/jerboa-client-error/": typeof DashJerboaClientErrorIndexRoute;
  "/jerboa-client-export/": typeof DashJerboaClientExportIndexRoute;
  "/jerboa-client-network-load/": typeof DashJerboaClientNetworkLoadIndexRoute;
  "/jerboa-client-preview/": typeof DashJerboaClientPreviewIndexRoute;
  "/jerboa-codec-report/": typeof DashJerboaCodecReportIndexRoute;
  "/jerboa-editor-session/": typeof DashJerboaEditorSessionIndexRoute;
  "/mcp/": typeof DashMcpIndexRoute;
  "/moderation/": typeof DashModerationIndexRoute;
  "/org-by-default": typeof DashOrgByDefaultIndexRoute;
  "/organizations/": typeof DashOrganizationsIndexRoute;
  "/projects/": typeof DashProjectsIndexRoute;
  "/session-replays/": typeof DashSessionReplaysIndexRoute;
  "/studio-edits/": typeof DashStudioEditsIndexRoute;
  "/users/": typeof DashUsersIndexRoute;
  "/videos/": typeof DashVideosIndexRoute;
  "/ai-edit-tool/new/vst": typeof DashAiEditToolNewVstRoute;
  "/ai-edit-tool/sst/$shotStyleId": typeof DashAiEditToolSstShotStyleIdRoute;
  "/ai-edits/agave-shadow-renders/$shadowRenderId": typeof DashAiEditsAgaveShadowRendersShadowRenderIdRoute;
  "/ai-edits/evals/$runId": typeof DashAiEditsEvalsRunIdRoute;
  "/basecamp/evals/$comparisonId": typeof DashBasecampEvalsComparisonIdRoute;
  "/capcode/reviews/$docId": typeof DashCapcodeReviewsDocIdRoute;
  "/charges/organizations/$orgId": typeof DashChargesOrganizationsOrgIdRoute;
  "/charges/users/$userId": typeof DashChargesUsersUserIdRoute;
  "/jerboa/ai-edit-fx-shadowing/$resultId": typeof DashJerboaAiEditFxShadowingResultIdRoute;
  "/jerboa/rendering-results/$resultId": typeof DashJerboaRenderingResultsResultIdRoute;
  "/linkedin-skills/users/$userId": typeof DashLinkedinSkillsUsersUserIdRoute;
  "/mcp/skills/$skill": typeof DashMcpSkillsSkillRoute;
  "/organizations/view/$orgId": typeof DashOrganizationsViewOrgIdRoute;
  "/studio-edits/view/$videoId": typeof DashStudioEditsViewVideoIdRoute;
  "/users/delete-account/$userId": typeof DashUsersDeleteAccountUserIdRoute;
  "/users/force-sign-out/$userId": typeof DashUsersForceSignOutUserIdRoute;
  "/users/undelete-account/$userId": typeof DashUsersUndeleteAccountUserIdRoute;
  "/users/view/$userId": typeof DashUsersViewUserIdRoute;
  "/videos/evals/$testId": typeof DashVideosEvalsTestIdRouteWithChildren;
  "/videos/segment-eval/admin": typeof DashVideosSegmentEvalAdminRoute;
  "/videos/segment-eval/results": typeof DashVideosSegmentEvalResultsRoute;
  "/videos/view/$videoId": typeof DashVideosViewVideoIdRoute;
  "/ai-edits/cactus-tools/": typeof DashAiEditsCactusToolsIndexRoute;
  "/ai-edits/evals/": typeof DashAiEditsEvalsIndexRoute;
  "/basecamp/evals/": typeof DashBasecampEvalsIndexRoute;
  "/basecamp/user-outputs": typeof DashBasecampUserOutputsIndexRoute;
  "/capcode/reviews": typeof DashCapcodeReviewsIndexRoute;
  "/cloudflare-redirects/remove": typeof DashCloudflareRedirectsRemoveIndexRoute;
  "/jerboa/ai-edit-fx-shadowing/": typeof DashJerboaAiEditFxShadowingIndexRoute;
  "/jerboa/rendering-results/": typeof DashJerboaRenderingResultsIndexRoute;
  "/videos/evals/": typeof DashVideosEvalsIndexRoute;
  "/videos/segment-eval": typeof DashVideosSegmentEvalIndexRoute;
  "/ai-edit-tool/new/sst/$videoStyleId": typeof DashAiEditToolNewSstVideoStyleIdRoute;
  "/ai-edits/cactus-tools/$workflowIdentifier/$workflowRunId": typeof DashAiEditsCactusToolsWorkflowIdentifierWorkflowRunIdRoute;
  "/ai-edits/evals/comparisons/$comparisonId": typeof DashAiEditsEvalsComparisonsComparisonIdRoute;
  "/ai-edits/evals/pairwise/$comparisonId": typeof DashAiEditsEvalsPairwiseComparisonIdRoute;
  "/videos/evals/$testId/rank": typeof DashVideosEvalsTestIdRankRoute;
  "/videos/evals/$testId/results": typeof DashVideosEvalsTestIdResultsRoute;
  "/videos/evals/dpo-review/$panelId": typeof DashVideosEvalsDpoReviewPanelIdRoute;
  "/videos/evals/dpo/$testId": typeof DashVideosEvalsDpoTestIdRoute;
  "/videos/evals/$testId/": typeof DashVideosEvalsTestIdIndexRoute;
  "/videos/evals/dpo-review": typeof DashVideosEvalsDpoReviewIndexRoute;
  "/videos/evals/dpo": typeof DashVideosEvalsDpoIndexRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/agave": typeof DashAgaveRoute;
  "/basecamp": typeof DashBasecampRouteWithChildren;
  "/basecamp-run-inspector": typeof DashBasecampRunInspectorRoute;
  "/basecamp-style-reviews": typeof DashBasecampStyleReviewsRoute;
  "/beta-waitlist": typeof DashBetaWaitlistRoute;
  "/employee": typeof DashEmployeeRoute;
  "/file-upload": typeof DashFileUploadRoute;
  "/home": typeof DashHomeRoute;
  "/human-editing-requests": typeof DashHumanEditingRequestsRoute;
  "/jerboa": typeof DashJerboaRouteWithChildren;
  "/linkedin-skills": typeof DashLinkedinSkillsRouteWithChildren;
  "/ltv": typeof DashLtvRouteWithChildren;
  "/profile": typeof DashProfileRoute;
  "/release-history": typeof DashReleaseHistoryRoute;
  "/session": typeof DashSessionRoute;
  "/youtube-download": typeof DashYoutubeDownloadRoute;
  "/auth/callback": typeof AuthCallbackRoute;
  "/auth/cap-code-mcp": typeof AuthCapCodeMcpRoute;
  "/ai-edits/$operationId": typeof DashAiEditsOperationIdRoute;
  "/ai-edits/agave-operation-graph": typeof DashAiEditsAgaveOperationGraphRoute;
  "/ai-edits/agave-operations": typeof DashAiEditsAgaveOperationsRoute;
  "/ai-edits/agave-shadows": typeof DashAiEditsAgaveShadowsRoute;
  "/ai-edits/all": typeof DashAiEditsAllRoute;
  "/ai-edits/long-to-short": typeof DashAiEditsLongToShortRoute;
  "/ai-edits/prompt-to-video": typeof DashAiEditsPromptToVideoRoute;
  "/capcode/review-feedback": typeof DashCapcodeReviewFeedbackRoute;
  "/caption-templates/$templateId": typeof DashCaptionTemplatesTemplateIdRoute;
  "/creator-styles/$styleId": typeof DashCreatorStylesStyleIdRoute;
  "/jerboa-client-error/$id": typeof DashJerboaClientErrorIdRoute;
  "/jerboa-client-export/$id": typeof DashJerboaClientExportIdRoute;
  "/jerboa-client-network-load/$id": typeof DashJerboaClientNetworkLoadIdRoute;
  "/jerboa-client-preview/$id": typeof DashJerboaClientPreviewIdRoute;
  "/jerboa-codec-report/$id": typeof DashJerboaCodecReportIdRoute;
  "/jerboa-editor-session/$id": typeof DashJerboaEditorSessionIdRoute;
  "/ltv/appsflyer-send-audit": typeof DashLtvAppsflyerSendAuditRoute;
  "/ltv/meta-send-audit": typeof DashLtvMetaSendAuditRoute;
  "/projects/$projectId": typeof DashProjectsProjectIdRoute;
  "/projects/animation-library": typeof DashProjectsAnimationLibraryRoute;
  "/projects/chats": typeof DashProjectsChatsRoute;
  "/projects/search": typeof DashProjectsSearchRoute;
  "/projects/tesseract": typeof DashProjectsTesseractRoute;
  "/review-feedback/$feedbackId": typeof DashReviewFeedbackFeedbackIdRoute;
  "/session-replays/$replayId": typeof DashSessionReplaysReplayIdRoute;
  "/users/internal-accounts": typeof DashUsersInternalAccountsRoute;
  "/users/internal-test-accounts": typeof DashUsersInternalTestAccountsRoute;
  "/videos/bookmarked": typeof DashVideosBookmarkedRoute;
  "/actors": typeof DashActorsIndexRoute;
  "/ai-edit-tool": typeof DashAiEditToolIndexRoute;
  "/ai-edits": typeof DashAiEditsIndexRoute;
  "/audio": typeof DashAudioIndexRoute;
  "/capcode": typeof DashCapcodeIndexRoute;
  "/caption-templates": typeof DashCaptionTemplatesIndexRoute;
  "/cloudflare-redirects": typeof DashCloudflareRedirectsIndexRoute;
  "/creator-styles": typeof DashCreatorStylesIndexRoute;
  "/credits": typeof DashCreditsIndexRoute;
  "/jerboa-client-error": typeof DashJerboaClientErrorIndexRoute;
  "/jerboa-client-export": typeof DashJerboaClientExportIndexRoute;
  "/jerboa-client-network-load": typeof DashJerboaClientNetworkLoadIndexRoute;
  "/jerboa-client-preview": typeof DashJerboaClientPreviewIndexRoute;
  "/jerboa-codec-report": typeof DashJerboaCodecReportIndexRoute;
  "/jerboa-editor-session": typeof DashJerboaEditorSessionIndexRoute;
  "/mcp": typeof DashMcpIndexRoute;
  "/moderation": typeof DashModerationIndexRoute;
  "/org-by-default": typeof DashOrgByDefaultIndexRoute;
  "/organizations": typeof DashOrganizationsIndexRoute;
  "/projects": typeof DashProjectsIndexRoute;
  "/session-replays": typeof DashSessionReplaysIndexRoute;
  "/studio-edits": typeof DashStudioEditsIndexRoute;
  "/users": typeof DashUsersIndexRoute;
  "/videos": typeof DashVideosIndexRoute;
  "/ai-edit-tool/new/vst": typeof DashAiEditToolNewVstRoute;
  "/ai-edit-tool/sst/$shotStyleId": typeof DashAiEditToolSstShotStyleIdRoute;
  "/ai-edits/agave-shadow-renders/$shadowRenderId": typeof DashAiEditsAgaveShadowRendersShadowRenderIdRoute;
  "/ai-edits/evals/$runId": typeof DashAiEditsEvalsRunIdRoute;
  "/basecamp/evals/$comparisonId": typeof DashBasecampEvalsComparisonIdRoute;
  "/capcode/reviews/$docId": typeof DashCapcodeReviewsDocIdRoute;
  "/charges/organizations/$orgId": typeof DashChargesOrganizationsOrgIdRoute;
  "/charges/users/$userId": typeof DashChargesUsersUserIdRoute;
  "/jerboa/ai-edit-fx-shadowing/$resultId": typeof DashJerboaAiEditFxShadowingResultIdRoute;
  "/jerboa/rendering-results/$resultId": typeof DashJerboaRenderingResultsResultIdRoute;
  "/linkedin-skills/users/$userId": typeof DashLinkedinSkillsUsersUserIdRoute;
  "/mcp/skills/$skill": typeof DashMcpSkillsSkillRoute;
  "/organizations/view/$orgId": typeof DashOrganizationsViewOrgIdRoute;
  "/studio-edits/view/$videoId": typeof DashStudioEditsViewVideoIdRoute;
  "/users/delete-account/$userId": typeof DashUsersDeleteAccountUserIdRoute;
  "/users/force-sign-out/$userId": typeof DashUsersForceSignOutUserIdRoute;
  "/users/undelete-account/$userId": typeof DashUsersUndeleteAccountUserIdRoute;
  "/users/view/$userId": typeof DashUsersViewUserIdRoute;
  "/videos/segment-eval/admin": typeof DashVideosSegmentEvalAdminRoute;
  "/videos/segment-eval/results": typeof DashVideosSegmentEvalResultsRoute;
  "/videos/view/$videoId": typeof DashVideosViewVideoIdRoute;
  "/ai-edits/cactus-tools": typeof DashAiEditsCactusToolsIndexRoute;
  "/ai-edits/evals": typeof DashAiEditsEvalsIndexRoute;
  "/basecamp/evals": typeof DashBasecampEvalsIndexRoute;
  "/basecamp/user-outputs": typeof DashBasecampUserOutputsIndexRoute;
  "/capcode/reviews": typeof DashCapcodeReviewsIndexRoute;
  "/cloudflare-redirects/remove": typeof DashCloudflareRedirectsRemoveIndexRoute;
  "/jerboa/ai-edit-fx-shadowing": typeof DashJerboaAiEditFxShadowingIndexRoute;
  "/jerboa/rendering-results": typeof DashJerboaRenderingResultsIndexRoute;
  "/videos/evals": typeof DashVideosEvalsIndexRoute;
  "/videos/segment-eval": typeof DashVideosSegmentEvalIndexRoute;
  "/ai-edit-tool/new/sst/$videoStyleId": typeof DashAiEditToolNewSstVideoStyleIdRoute;
  "/ai-edits/cactus-tools/$workflowIdentifier/$workflowRunId": typeof DashAiEditsCactusToolsWorkflowIdentifierWorkflowRunIdRoute;
  "/ai-edits/evals/comparisons/$comparisonId": typeof DashAiEditsEvalsComparisonsComparisonIdRoute;
  "/ai-edits/evals/pairwise/$comparisonId": typeof DashAiEditsEvalsPairwiseComparisonIdRoute;
  "/videos/evals/$testId/rank": typeof DashVideosEvalsTestIdRankRoute;
  "/videos/evals/$testId/results": typeof DashVideosEvalsTestIdResultsRoute;
  "/videos/evals/dpo-review/$panelId": typeof DashVideosEvalsDpoReviewPanelIdRoute;
  "/videos/evals/dpo/$testId": typeof DashVideosEvalsDpoTestIdRoute;
  "/videos/evals/$testId": typeof DashVideosEvalsTestIdIndexRoute;
  "/videos/evals/dpo-review": typeof DashVideosEvalsDpoReviewIndexRoute;
  "/videos/evals/dpo": typeof DashVideosEvalsDpoIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/_dash": typeof DashRouteWithChildren;
  "/_dash/actors": typeof DashActorsRouteWithChildren;
  "/_dash/agave": typeof DashAgaveRoute;
  "/_dash/ai-edit-tool": typeof DashAiEditToolRouteWithChildren;
  "/_dash/ai-edits": typeof DashAiEditsRouteWithChildren;
  "/_dash/audio": typeof DashAudioRouteWithChildren;
  "/_dash/basecamp": typeof DashBasecampRouteWithChildren;
  "/_dash/basecamp-run-inspector": typeof DashBasecampRunInspectorRoute;
  "/_dash/basecamp-style-reviews": typeof DashBasecampStyleReviewsRoute;
  "/_dash/beta-waitlist": typeof DashBetaWaitlistRoute;
  "/_dash/capcode": typeof DashCapcodeRouteWithChildren;
  "/_dash/caption-templates": typeof DashCaptionTemplatesRouteWithChildren;
  "/_dash/cloudflare-redirects": typeof DashCloudflareRedirectsRouteWithChildren;
  "/_dash/creator-styles": typeof DashCreatorStylesRouteWithChildren;
  "/_dash/credits": typeof DashCreditsRouteWithChildren;
  "/_dash/employee": typeof DashEmployeeRoute;
  "/_dash/file-upload": typeof DashFileUploadRoute;
  "/_dash/home": typeof DashHomeRoute;
  "/_dash/human-editing-requests": typeof DashHumanEditingRequestsRoute;
  "/_dash/jerboa": typeof DashJerboaRouteWithChildren;
  "/_dash/jerboa-client-error": typeof DashJerboaClientErrorRouteWithChildren;
  "/_dash/jerboa-client-export": typeof DashJerboaClientExportRouteWithChildren;
  "/_dash/jerboa-client-network-load": typeof DashJerboaClientNetworkLoadRouteWithChildren;
  "/_dash/jerboa-client-preview": typeof DashJerboaClientPreviewRouteWithChildren;
  "/_dash/jerboa-codec-report": typeof DashJerboaCodecReportRouteWithChildren;
  "/_dash/jerboa-editor-session": typeof DashJerboaEditorSessionRouteWithChildren;
  "/_dash/linkedin-skills": typeof DashLinkedinSkillsRouteWithChildren;
  "/_dash/ltv": typeof DashLtvRouteWithChildren;
  "/_dash/mcp": typeof DashMcpRouteWithChildren;
  "/_dash/moderation": typeof DashModerationRouteWithChildren;
  "/_dash/organizations": typeof DashOrganizationsRouteWithChildren;
  "/_dash/profile": typeof DashProfileRoute;
  "/_dash/projects": typeof DashProjectsRouteWithChildren;
  "/_dash/release-history": typeof DashReleaseHistoryRoute;
  "/_dash/session": typeof DashSessionRoute;
  "/_dash/session-replays": typeof DashSessionReplaysRouteWithChildren;
  "/_dash/studio-edits": typeof DashStudioEditsRouteWithChildren;
  "/_dash/users": typeof DashUsersRouteWithChildren;
  "/_dash/videos": typeof DashVideosRouteWithChildren;
  "/_dash/youtube-download": typeof DashYoutubeDownloadRoute;
  "/auth/callback": typeof AuthCallbackRoute;
  "/auth/cap-code-mcp": typeof AuthCapCodeMcpRoute;
  "/_dash/ai-edits/$operationId": typeof DashAiEditsOperationIdRoute;
  "/_dash/ai-edits/agave-operation-graph": typeof DashAiEditsAgaveOperationGraphRoute;
  "/_dash/ai-edits/agave-operations": typeof DashAiEditsAgaveOperationsRoute;
  "/_dash/ai-edits/agave-shadows": typeof DashAiEditsAgaveShadowsRoute;
  "/_dash/ai-edits/all": typeof DashAiEditsAllRoute;
  "/_dash/ai-edits/cactus-tools": typeof DashAiEditsCactusToolsRouteWithChildren;
  "/_dash/ai-edits/evals": typeof DashAiEditsEvalsRouteWithChildren;
  "/_dash/ai-edits/long-to-short": typeof DashAiEditsLongToShortRoute;
  "/_dash/ai-edits/prompt-to-video": typeof DashAiEditsPromptToVideoRoute;
  "/_dash/basecamp/evals": typeof DashBasecampEvalsRouteWithChildren;
  "/_dash/capcode/review-feedback": typeof DashCapcodeReviewFeedbackRoute;
  "/_dash/caption-templates/$templateId": typeof DashCaptionTemplatesTemplateIdRoute;
  "/_dash/creator-styles/$styleId": typeof DashCreatorStylesStyleIdRoute;
  "/_dash/jerboa-client-error/$id": typeof DashJerboaClientErrorIdRoute;
  "/_dash/jerboa-client-export/$id": typeof DashJerboaClientExportIdRoute;
  "/_dash/jerboa-client-network-load/$id": typeof DashJerboaClientNetworkLoadIdRoute;
  "/_dash/jerboa-client-preview/$id": typeof DashJerboaClientPreviewIdRoute;
  "/_dash/jerboa-codec-report/$id": typeof DashJerboaCodecReportIdRoute;
  "/_dash/jerboa-editor-session/$id": typeof DashJerboaEditorSessionIdRoute;
  "/_dash/jerboa/ai-edit-fx-shadowing": typeof DashJerboaAiEditFxShadowingRouteWithChildren;
  "/_dash/jerboa/rendering-results": typeof DashJerboaRenderingResultsRouteWithChildren;
  "/_dash/ltv/appsflyer-send-audit": typeof DashLtvAppsflyerSendAuditRoute;
  "/_dash/ltv/meta-send-audit": typeof DashLtvMetaSendAuditRoute;
  "/_dash/projects/$projectId": typeof DashProjectsProjectIdRoute;
  "/_dash/projects/animation-library": typeof DashProjectsAnimationLibraryRoute;
  "/_dash/projects/chats": typeof DashProjectsChatsRoute;
  "/_dash/projects/search": typeof DashProjectsSearchRoute;
  "/_dash/projects/tesseract": typeof DashProjectsTesseractRoute;
  "/_dash/review-feedback/$feedbackId": typeof DashReviewFeedbackFeedbackIdRoute;
  "/_dash/session-replays/$replayId": typeof DashSessionReplaysReplayIdRoute;
  "/_dash/users/internal-accounts": typeof DashUsersInternalAccountsRoute;
  "/_dash/users/internal-test-accounts": typeof DashUsersInternalTestAccountsRoute;
  "/_dash/videos/bookmarked": typeof DashVideosBookmarkedRoute;
  "/_dash/videos/evals": typeof DashVideosEvalsRouteWithChildren;
  "/_dash/actors/": typeof DashActorsIndexRoute;
  "/_dash/ai-edit-tool/": typeof DashAiEditToolIndexRoute;
  "/_dash/ai-edits/": typeof DashAiEditsIndexRoute;
  "/_dash/audio/": typeof DashAudioIndexRoute;
  "/_dash/capcode/": typeof DashCapcodeIndexRoute;
  "/_dash/caption-templates/": typeof DashCaptionTemplatesIndexRoute;
  "/_dash/cloudflare-redirects/": typeof DashCloudflareRedirectsIndexRoute;
  "/_dash/creator-styles/": typeof DashCreatorStylesIndexRoute;
  "/_dash/credits/": typeof DashCreditsIndexRoute;
  "/_dash/jerboa-client-error/": typeof DashJerboaClientErrorIndexRoute;
  "/_dash/jerboa-client-export/": typeof DashJerboaClientExportIndexRoute;
  "/_dash/jerboa-client-network-load/": typeof DashJerboaClientNetworkLoadIndexRoute;
  "/_dash/jerboa-client-preview/": typeof DashJerboaClientPreviewIndexRoute;
  "/_dash/jerboa-codec-report/": typeof DashJerboaCodecReportIndexRoute;
  "/_dash/jerboa-editor-session/": typeof DashJerboaEditorSessionIndexRoute;
  "/_dash/mcp/": typeof DashMcpIndexRoute;
  "/_dash/moderation/": typeof DashModerationIndexRoute;
  "/_dash/org-by-default/": typeof DashOrgByDefaultIndexRoute;
  "/_dash/organizations/": typeof DashOrganizationsIndexRoute;
  "/_dash/projects/": typeof DashProjectsIndexRoute;
  "/_dash/session-replays/": typeof DashSessionReplaysIndexRoute;
  "/_dash/studio-edits/": typeof DashStudioEditsIndexRoute;
  "/_dash/users/": typeof DashUsersIndexRoute;
  "/_dash/videos/": typeof DashVideosIndexRoute;
  "/_dash/ai-edit-tool/new/vst": typeof DashAiEditToolNewVstRoute;
  "/_dash/ai-edit-tool/sst/$shotStyleId": typeof DashAiEditToolSstShotStyleIdRoute;
  "/_dash/ai-edits/agave-shadow-renders/$shadowRenderId": typeof DashAiEditsAgaveShadowRendersShadowRenderIdRoute;
  "/_dash/ai-edits/evals/$runId": typeof DashAiEditsEvalsRunIdRoute;
  "/_dash/basecamp/evals/$comparisonId": typeof DashBasecampEvalsComparisonIdRoute;
  "/_dash/capcode/reviews/$docId": typeof DashCapcodeReviewsDocIdRoute;
  "/_dash/charges/organizations/$orgId": typeof DashChargesOrganizationsOrgIdRoute;
  "/_dash/charges/users/$userId": typeof DashChargesUsersUserIdRoute;
  "/_dash/jerboa/ai-edit-fx-shadowing/$resultId": typeof DashJerboaAiEditFxShadowingResultIdRoute;
  "/_dash/jerboa/rendering-results/$resultId": typeof DashJerboaRenderingResultsResultIdRoute;
  "/_dash/linkedin-skills/users/$userId": typeof DashLinkedinSkillsUsersUserIdRoute;
  "/_dash/mcp/skills/$skill": typeof DashMcpSkillsSkillRoute;
  "/_dash/organizations/view/$orgId": typeof DashOrganizationsViewOrgIdRoute;
  "/_dash/studio-edits/view/$videoId": typeof DashStudioEditsViewVideoIdRoute;
  "/_dash/users/delete-account/$userId": typeof DashUsersDeleteAccountUserIdRoute;
  "/_dash/users/force-sign-out/$userId": typeof DashUsersForceSignOutUserIdRoute;
  "/_dash/users/undelete-account/$userId": typeof DashUsersUndeleteAccountUserIdRoute;
  "/_dash/users/view/$userId": typeof DashUsersViewUserIdRoute;
  "/_dash/videos/evals/$testId": typeof DashVideosEvalsTestIdRouteWithChildren;
  "/_dash/videos/segment-eval/admin": typeof DashVideosSegmentEvalAdminRoute;
  "/_dash/videos/segment-eval/results": typeof DashVideosSegmentEvalResultsRoute;
  "/_dash/videos/view/$videoId": typeof DashVideosViewVideoIdRoute;
  "/_dash/ai-edits/cactus-tools/": typeof DashAiEditsCactusToolsIndexRoute;
  "/_dash/ai-edits/evals/": typeof DashAiEditsEvalsIndexRoute;
  "/_dash/basecamp/evals/": typeof DashBasecampEvalsIndexRoute;
  "/_dash/basecamp/user-outputs/": typeof DashBasecampUserOutputsIndexRoute;
  "/_dash/capcode/reviews/": typeof DashCapcodeReviewsIndexRoute;
  "/_dash/cloudflare-redirects/remove/": typeof DashCloudflareRedirectsRemoveIndexRoute;
  "/_dash/jerboa/ai-edit-fx-shadowing/": typeof DashJerboaAiEditFxShadowingIndexRoute;
  "/_dash/jerboa/rendering-results/": typeof DashJerboaRenderingResultsIndexRoute;
  "/_dash/videos/evals/": typeof DashVideosEvalsIndexRoute;
  "/_dash/videos/segment-eval/": typeof DashVideosSegmentEvalIndexRoute;
  "/_dash/ai-edit-tool/new/sst/$videoStyleId": typeof DashAiEditToolNewSstVideoStyleIdRoute;
  "/_dash/ai-edits/cactus-tools/$workflowIdentifier/$workflowRunId": typeof DashAiEditsCactusToolsWorkflowIdentifierWorkflowRunIdRoute;
  "/_dash/ai-edits/evals/comparisons/$comparisonId": typeof DashAiEditsEvalsComparisonsComparisonIdRoute;
  "/_dash/ai-edits/evals/pairwise/$comparisonId": typeof DashAiEditsEvalsPairwiseComparisonIdRoute;
  "/_dash/videos/evals/$testId/rank": typeof DashVideosEvalsTestIdRankRoute;
  "/_dash/videos/evals/$testId/results": typeof DashVideosEvalsTestIdResultsRoute;
  "/_dash/videos/evals/dpo-review/$panelId": typeof DashVideosEvalsDpoReviewPanelIdRoute;
  "/_dash/videos/evals/dpo/$testId": typeof DashVideosEvalsDpoTestIdRoute;
  "/_dash/videos/evals/$testId/": typeof DashVideosEvalsTestIdIndexRoute;
  "/_dash/videos/evals/dpo-review/": typeof DashVideosEvalsDpoReviewIndexRoute;
  "/_dash/videos/evals/dpo/": typeof DashVideosEvalsDpoIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/actors"
    | "/agave"
    | "/ai-edit-tool"
    | "/ai-edits"
    | "/audio"
    | "/basecamp"
    | "/basecamp-run-inspector"
    | "/basecamp-style-reviews"
    | "/beta-waitlist"
    | "/capcode"
    | "/caption-templates"
    | "/cloudflare-redirects"
    | "/creator-styles"
    | "/credits"
    | "/employee"
    | "/file-upload"
    | "/home"
    | "/human-editing-requests"
    | "/jerboa"
    | "/jerboa-client-error"
    | "/jerboa-client-export"
    | "/jerboa-client-network-load"
    | "/jerboa-client-preview"
    | "/jerboa-codec-report"
    | "/jerboa-editor-session"
    | "/linkedin-skills"
    | "/ltv"
    | "/mcp"
    | "/moderation"
    | "/organizations"
    | "/profile"
    | "/projects"
    | "/release-history"
    | "/session"
    | "/session-replays"
    | "/studio-edits"
    | "/users"
    | "/videos"
    | "/youtube-download"
    | "/auth/callback"
    | "/auth/cap-code-mcp"
    | "/ai-edits/$operationId"
    | "/ai-edits/agave-operation-graph"
    | "/ai-edits/agave-operations"
    | "/ai-edits/agave-shadows"
    | "/ai-edits/all"
    | "/ai-edits/cactus-tools"
    | "/ai-edits/evals"
    | "/ai-edits/long-to-short"
    | "/ai-edits/prompt-to-video"
    | "/basecamp/evals"
    | "/capcode/review-feedback"
    | "/caption-templates/$templateId"
    | "/creator-styles/$styleId"
    | "/jerboa-client-error/$id"
    | "/jerboa-client-export/$id"
    | "/jerboa-client-network-load/$id"
    | "/jerboa-client-preview/$id"
    | "/jerboa-codec-report/$id"
    | "/jerboa-editor-session/$id"
    | "/jerboa/ai-edit-fx-shadowing"
    | "/jerboa/rendering-results"
    | "/ltv/appsflyer-send-audit"
    | "/ltv/meta-send-audit"
    | "/projects/$projectId"
    | "/projects/animation-library"
    | "/projects/chats"
    | "/projects/search"
    | "/projects/tesseract"
    | "/review-feedback/$feedbackId"
    | "/session-replays/$replayId"
    | "/users/internal-accounts"
    | "/users/internal-test-accounts"
    | "/videos/bookmarked"
    | "/videos/evals"
    | "/actors/"
    | "/ai-edit-tool/"
    | "/ai-edits/"
    | "/audio/"
    | "/capcode/"
    | "/caption-templates/"
    | "/cloudflare-redirects/"
    | "/creator-styles/"
    | "/credits/"
    | "/jerboa-client-error/"
    | "/jerboa-client-export/"
    | "/jerboa-client-network-load/"
    | "/jerboa-client-preview/"
    | "/jerboa-codec-report/"
    | "/jerboa-editor-session/"
    | "/mcp/"
    | "/moderation/"
    | "/org-by-default"
    | "/organizations/"
    | "/projects/"
    | "/session-replays/"
    | "/studio-edits/"
    | "/users/"
    | "/videos/"
    | "/ai-edit-tool/new/vst"
    | "/ai-edit-tool/sst/$shotStyleId"
    | "/ai-edits/agave-shadow-renders/$shadowRenderId"
    | "/ai-edits/evals/$runId"
    | "/basecamp/evals/$comparisonId"
    | "/capcode/reviews/$docId"
    | "/charges/organizations/$orgId"
    | "/charges/users/$userId"
    | "/jerboa/ai-edit-fx-shadowing/$resultId"
    | "/jerboa/rendering-results/$resultId"
    | "/linkedin-skills/users/$userId"
    | "/mcp/skills/$skill"
    | "/organizations/view/$orgId"
    | "/studio-edits/view/$videoId"
    | "/users/delete-account/$userId"
    | "/users/force-sign-out/$userId"
    | "/users/undelete-account/$userId"
    | "/users/view/$userId"
    | "/videos/evals/$testId"
    | "/videos/segment-eval/admin"
    | "/videos/segment-eval/results"
    | "/videos/view/$videoId"
    | "/ai-edits/cactus-tools/"
    | "/ai-edits/evals/"
    | "/basecamp/evals/"
    | "/basecamp/user-outputs"
    | "/capcode/reviews"
    | "/cloudflare-redirects/remove"
    | "/jerboa/ai-edit-fx-shadowing/"
    | "/jerboa/rendering-results/"
    | "/videos/evals/"
    | "/videos/segment-eval"
    | "/ai-edit-tool/new/sst/$videoStyleId"
    | "/ai-edits/cactus-tools/$workflowIdentifier/$workflowRunId"
    | "/ai-edits/evals/comparisons/$comparisonId"
    | "/ai-edits/evals/pairwise/$comparisonId"
    | "/videos/evals/$testId/rank"
    | "/videos/evals/$testId/results"
    | "/videos/evals/dpo-review/$panelId"
    | "/videos/evals/dpo/$testId"
    | "/videos/evals/$testId/"
    | "/videos/evals/dpo-review"
    | "/videos/evals/dpo";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/agave"
    | "/basecamp"
    | "/basecamp-run-inspector"
    | "/basecamp-style-reviews"
    | "/beta-waitlist"
    | "/employee"
    | "/file-upload"
    | "/home"
    | "/human-editing-requests"
    | "/jerboa"
    | "/linkedin-skills"
    | "/ltv"
    | "/profile"
    | "/release-history"
    | "/session"
    | "/youtube-download"
    | "/auth/callback"
    | "/auth/cap-code-mcp"
    | "/ai-edits/$operationId"
    | "/ai-edits/agave-operation-graph"
    | "/ai-edits/agave-operations"
    | "/ai-edits/agave-shadows"
    | "/ai-edits/all"
    | "/ai-edits/long-to-short"
    | "/ai-edits/prompt-to-video"
    | "/capcode/review-feedback"
    | "/caption-templates/$templateId"
    | "/creator-styles/$styleId"
    | "/jerboa-client-error/$id"
    | "/jerboa-client-export/$id"
    | "/jerboa-client-network-load/$id"
    | "/jerboa-client-preview/$id"
    | "/jerboa-codec-report/$id"
    | "/jerboa-editor-session/$id"
    | "/ltv/appsflyer-send-audit"
    | "/ltv/meta-send-audit"
    | "/projects/$projectId"
    | "/projects/animation-library"
    | "/projects/chats"
    | "/projects/search"
    | "/projects/tesseract"
    | "/review-feedback/$feedbackId"
    | "/session-replays/$replayId"
    | "/users/internal-accounts"
    | "/users/internal-test-accounts"
    | "/videos/bookmarked"
    | "/actors"
    | "/ai-edit-tool"
    | "/ai-edits"
    | "/audio"
    | "/capcode"
    | "/caption-templates"
    | "/cloudflare-redirects"
    | "/creator-styles"
    | "/credits"
    | "/jerboa-client-error"
    | "/jerboa-client-export"
    | "/jerboa-client-network-load"
    | "/jerboa-client-preview"
    | "/jerboa-codec-report"
    | "/jerboa-editor-session"
    | "/mcp"
    | "/moderation"
    | "/org-by-default"
    | "/organizations"
    | "/projects"
    | "/session-replays"
    | "/studio-edits"
    | "/users"
    | "/videos"
    | "/ai-edit-tool/new/vst"
    | "/ai-edit-tool/sst/$shotStyleId"
    | "/ai-edits/agave-shadow-renders/$shadowRenderId"
    | "/ai-edits/evals/$runId"
    | "/basecamp/evals/$comparisonId"
    | "/capcode/reviews/$docId"
    | "/charges/organizations/$orgId"
    | "/charges/users/$userId"
    | "/jerboa/ai-edit-fx-shadowing/$resultId"
    | "/jerboa/rendering-results/$resultId"
    | "/linkedin-skills/users/$userId"
    | "/mcp/skills/$skill"
    | "/organizations/view/$orgId"
    | "/studio-edits/view/$videoId"
    | "/users/delete-account/$userId"
    | "/users/force-sign-out/$userId"
    | "/users/undelete-account/$userId"
    | "/users/view/$userId"
    | "/videos/segment-eval/admin"
    | "/videos/segment-eval/results"
    | "/videos/view/$videoId"
    | "/ai-edits/cactus-tools"
    | "/ai-edits/evals"
    | "/basecamp/evals"
    | "/basecamp/user-outputs"
    | "/capcode/reviews"
    | "/cloudflare-redirects/remove"
    | "/jerboa/ai-edit-fx-shadowing"
    | "/jerboa/rendering-results"
    | "/videos/evals"
    | "/videos/segment-eval"
    | "/ai-edit-tool/new/sst/$videoStyleId"
    | "/ai-edits/cactus-tools/$workflowIdentifier/$workflowRunId"
    | "/ai-edits/evals/comparisons/$comparisonId"
    | "/ai-edits/evals/pairwise/$comparisonId"
    | "/videos/evals/$testId/rank"
    | "/videos/evals/$testId/results"
    | "/videos/evals/dpo-review/$panelId"
    | "/videos/evals/dpo/$testId"
    | "/videos/evals/$testId"
    | "/videos/evals/dpo-review"
    | "/videos/evals/dpo";
  id:
    | "__root__"
    | "/"
    | "/_dash"
    | "/_dash/actors"
    | "/_dash/agave"
    | "/_dash/ai-edit-tool"
    | "/_dash/ai-edits"
    | "/_dash/audio"
    | "/_dash/basecamp"
    | "/_dash/basecamp-run-inspector"
    | "/_dash/basecamp-style-reviews"
    | "/_dash/beta-waitlist"
    | "/_dash/capcode"
    | "/_dash/caption-templates"
    | "/_dash/cloudflare-redirects"
    | "/_dash/creator-styles"
    | "/_dash/credits"
    | "/_dash/employee"
    | "/_dash/file-upload"
    | "/_dash/home"
    | "/_dash/human-editing-requests"
    | "/_dash/jerboa"
    | "/_dash/jerboa-client-error"
    | "/_dash/jerboa-client-export"
    | "/_dash/jerboa-client-network-load"
    | "/_dash/jerboa-client-preview"
    | "/_dash/jerboa-codec-report"
    | "/_dash/jerboa-editor-session"
    | "/_dash/linkedin-skills"
    | "/_dash/ltv"
    | "/_dash/mcp"
    | "/_dash/moderation"
    | "/_dash/organizations"
    | "/_dash/profile"
    | "/_dash/projects"
    | "/_dash/release-history"
    | "/_dash/session"
    | "/_dash/session-replays"
    | "/_dash/studio-edits"
    | "/_dash/users"
    | "/_dash/videos"
    | "/_dash/youtube-download"
    | "/auth/callback"
    | "/auth/cap-code-mcp"
    | "/_dash/ai-edits/$operationId"
    | "/_dash/ai-edits/agave-operation-graph"
    | "/_dash/ai-edits/agave-operations"
    | "/_dash/ai-edits/agave-shadows"
    | "/_dash/ai-edits/all"
    | "/_dash/ai-edits/cactus-tools"
    | "/_dash/ai-edits/evals"
    | "/_dash/ai-edits/long-to-short"
    | "/_dash/ai-edits/prompt-to-video"
    | "/_dash/basecamp/evals"
    | "/_dash/capcode/review-feedback"
    | "/_dash/caption-templates/$templateId"
    | "/_dash/creator-styles/$styleId"
    | "/_dash/jerboa-client-error/$id"
    | "/_dash/jerboa-client-export/$id"
    | "/_dash/jerboa-client-network-load/$id"
    | "/_dash/jerboa-client-preview/$id"
    | "/_dash/jerboa-codec-report/$id"
    | "/_dash/jerboa-editor-session/$id"
    | "/_dash/jerboa/ai-edit-fx-shadowing"
    | "/_dash/jerboa/rendering-results"
    | "/_dash/ltv/appsflyer-send-audit"
    | "/_dash/ltv/meta-send-audit"
    | "/_dash/projects/$projectId"
    | "/_dash/projects/animation-library"
    | "/_dash/projects/chats"
    | "/_dash/projects/search"
    | "/_dash/projects/tesseract"
    | "/_dash/review-feedback/$feedbackId"
    | "/_dash/session-replays/$replayId"
    | "/_dash/users/internal-accounts"
    | "/_dash/users/internal-test-accounts"
    | "/_dash/videos/bookmarked"
    | "/_dash/videos/evals"
    | "/_dash/actors/"
    | "/_dash/ai-edit-tool/"
    | "/_dash/ai-edits/"
    | "/_dash/audio/"
    | "/_dash/capcode/"
    | "/_dash/caption-templates/"
    | "/_dash/cloudflare-redirects/"
    | "/_dash/creator-styles/"
    | "/_dash/credits/"
    | "/_dash/jerboa-client-error/"
    | "/_dash/jerboa-client-export/"
    | "/_dash/jerboa-client-network-load/"
    | "/_dash/jerboa-client-preview/"
    | "/_dash/jerboa-codec-report/"
    | "/_dash/jerboa-editor-session/"
    | "/_dash/mcp/"
    | "/_dash/moderation/"
    | "/_dash/org-by-default/"
    | "/_dash/organizations/"
    | "/_dash/projects/"
    | "/_dash/session-replays/"
    | "/_dash/studio-edits/"
    | "/_dash/users/"
    | "/_dash/videos/"
    | "/_dash/ai-edit-tool/new/vst"
    | "/_dash/ai-edit-tool/sst/$shotStyleId"
    | "/_dash/ai-edits/agave-shadow-renders/$shadowRenderId"
    | "/_dash/ai-edits/evals/$runId"
    | "/_dash/basecamp/evals/$comparisonId"
    | "/_dash/capcode/reviews/$docId"
    | "/_dash/charges/organizations/$orgId"
    | "/_dash/charges/users/$userId"
    | "/_dash/jerboa/ai-edit-fx-shadowing/$resultId"
    | "/_dash/jerboa/rendering-results/$resultId"
    | "/_dash/linkedin-skills/users/$userId"
    | "/_dash/mcp/skills/$skill"
    | "/_dash/organizations/view/$orgId"
    | "/_dash/studio-edits/view/$videoId"
    | "/_dash/users/delete-account/$userId"
    | "/_dash/users/force-sign-out/$userId"
    | "/_dash/users/undelete-account/$userId"
    | "/_dash/users/view/$userId"
    | "/_dash/videos/evals/$testId"
    | "/_dash/videos/segment-eval/admin"
    | "/_dash/videos/segment-eval/results"
    | "/_dash/videos/view/$videoId"
    | "/_dash/ai-edits/cactus-tools/"
    | "/_dash/ai-edits/evals/"
    | "/_dash/basecamp/evals/"
    | "/_dash/basecamp/user-outputs/"
    | "/_dash/capcode/reviews/"
    | "/_dash/cloudflare-redirects/remove/"
    | "/_dash/jerboa/ai-edit-fx-shadowing/"
    | "/_dash/jerboa/rendering-results/"
    | "/_dash/videos/evals/"
    | "/_dash/videos/segment-eval/"
    | "/_dash/ai-edit-tool/new/sst/$videoStyleId"
    | "/_dash/ai-edits/cactus-tools/$workflowIdentifier/$workflowRunId"
    | "/_dash/ai-edits/evals/comparisons/$comparisonId"
    | "/_dash/ai-edits/evals/pairwise/$comparisonId"
    | "/_dash/videos/evals/$testId/rank"
    | "/_dash/videos/evals/$testId/results"
    | "/_dash/videos/evals/dpo-review/$panelId"
    | "/_dash/videos/evals/dpo/$testId"
    | "/_dash/videos/evals/$testId/"
    | "/_dash/videos/evals/dpo-review/"
    | "/_dash/videos/evals/dpo/";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  DashRoute: typeof DashRouteWithChildren;
  AuthCallbackRoute: typeof AuthCallbackRoute;
  AuthCapCodeMcpRoute: typeof AuthCapCodeMcpRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_dash": {
      id: "/_dash";
      path: "";
      fullPath: "";
      preLoaderRoute: typeof DashRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/auth/cap-code-mcp": {
      id: "/auth/cap-code-mcp";
      path: "/auth/cap-code-mcp";
      fullPath: "/auth/cap-code-mcp";
      preLoaderRoute: typeof AuthCapCodeMcpRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/auth/callback": {
      id: "/auth/callback";
      path: "/auth/callback";
      fullPath: "/auth/callback";
      preLoaderRoute: typeof AuthCallbackRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_dash/youtube-download": {
      id: "/_dash/youtube-download";
      path: "/youtube-download";
      fullPath: "/youtube-download";
      preLoaderRoute: typeof DashYoutubeDownloadRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/videos": {
      id: "/_dash/videos";
      path: "/videos";
      fullPath: "/videos";
      preLoaderRoute: typeof DashVideosRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/users": {
      id: "/_dash/users";
      path: "/users";
      fullPath: "/users";
      preLoaderRoute: typeof DashUsersRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/studio-edits": {
      id: "/_dash/studio-edits";
      path: "/studio-edits";
      fullPath: "/studio-edits";
      preLoaderRoute: typeof DashStudioEditsRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/session-replays": {
      id: "/_dash/session-replays";
      path: "/session-replays";
      fullPath: "/session-replays";
      preLoaderRoute: typeof DashSessionReplaysRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/session": {
      id: "/_dash/session";
      path: "/session";
      fullPath: "/session";
      preLoaderRoute: typeof DashSessionRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/release-history": {
      id: "/_dash/release-history";
      path: "/release-history";
      fullPath: "/release-history";
      preLoaderRoute: typeof DashReleaseHistoryRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/projects": {
      id: "/_dash/projects";
      path: "/projects";
      fullPath: "/projects";
      preLoaderRoute: typeof DashProjectsRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/profile": {
      id: "/_dash/profile";
      path: "/profile";
      fullPath: "/profile";
      preLoaderRoute: typeof DashProfileRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/organizations": {
      id: "/_dash/organizations";
      path: "/organizations";
      fullPath: "/organizations";
      preLoaderRoute: typeof DashOrganizationsRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/moderation": {
      id: "/_dash/moderation";
      path: "/moderation";
      fullPath: "/moderation";
      preLoaderRoute: typeof DashModerationRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/mcp": {
      id: "/_dash/mcp";
      path: "/mcp";
      fullPath: "/mcp";
      preLoaderRoute: typeof DashMcpRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/ltv": {
      id: "/_dash/ltv";
      path: "/ltv";
      fullPath: "/ltv";
      preLoaderRoute: typeof DashLtvRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/linkedin-skills": {
      id: "/_dash/linkedin-skills";
      path: "/linkedin-skills";
      fullPath: "/linkedin-skills";
      preLoaderRoute: typeof DashLinkedinSkillsRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/jerboa-editor-session": {
      id: "/_dash/jerboa-editor-session";
      path: "/jerboa-editor-session";
      fullPath: "/jerboa-editor-session";
      preLoaderRoute: typeof DashJerboaEditorSessionRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/jerboa-codec-report": {
      id: "/_dash/jerboa-codec-report";
      path: "/jerboa-codec-report";
      fullPath: "/jerboa-codec-report";
      preLoaderRoute: typeof DashJerboaCodecReportRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/jerboa-client-preview": {
      id: "/_dash/jerboa-client-preview";
      path: "/jerboa-client-preview";
      fullPath: "/jerboa-client-preview";
      preLoaderRoute: typeof DashJerboaClientPreviewRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/jerboa-client-network-load": {
      id: "/_dash/jerboa-client-network-load";
      path: "/jerboa-client-network-load";
      fullPath: "/jerboa-client-network-load";
      preLoaderRoute: typeof DashJerboaClientNetworkLoadRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/jerboa-client-export": {
      id: "/_dash/jerboa-client-export";
      path: "/jerboa-client-export";
      fullPath: "/jerboa-client-export";
      preLoaderRoute: typeof DashJerboaClientExportRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/jerboa-client-error": {
      id: "/_dash/jerboa-client-error";
      path: "/jerboa-client-error";
      fullPath: "/jerboa-client-error";
      preLoaderRoute: typeof DashJerboaClientErrorRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/jerboa": {
      id: "/_dash/jerboa";
      path: "/jerboa";
      fullPath: "/jerboa";
      preLoaderRoute: typeof DashJerboaRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/human-editing-requests": {
      id: "/_dash/human-editing-requests";
      path: "/human-editing-requests";
      fullPath: "/human-editing-requests";
      preLoaderRoute: typeof DashHumanEditingRequestsRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/home": {
      id: "/_dash/home";
      path: "/home";
      fullPath: "/home";
      preLoaderRoute: typeof DashHomeRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/file-upload": {
      id: "/_dash/file-upload";
      path: "/file-upload";
      fullPath: "/file-upload";
      preLoaderRoute: typeof DashFileUploadRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/employee": {
      id: "/_dash/employee";
      path: "/employee";
      fullPath: "/employee";
      preLoaderRoute: typeof DashEmployeeRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/credits": {
      id: "/_dash/credits";
      path: "/credits";
      fullPath: "/credits";
      preLoaderRoute: typeof DashCreditsRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/creator-styles": {
      id: "/_dash/creator-styles";
      path: "/creator-styles";
      fullPath: "/creator-styles";
      preLoaderRoute: typeof DashCreatorStylesRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/cloudflare-redirects": {
      id: "/_dash/cloudflare-redirects";
      path: "/cloudflare-redirects";
      fullPath: "/cloudflare-redirects";
      preLoaderRoute: typeof DashCloudflareRedirectsRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/caption-templates": {
      id: "/_dash/caption-templates";
      path: "/caption-templates";
      fullPath: "/caption-templates";
      preLoaderRoute: typeof DashCaptionTemplatesRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/capcode": {
      id: "/_dash/capcode";
      path: "/capcode";
      fullPath: "/capcode";
      preLoaderRoute: typeof DashCapcodeRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/beta-waitlist": {
      id: "/_dash/beta-waitlist";
      path: "/beta-waitlist";
      fullPath: "/beta-waitlist";
      preLoaderRoute: typeof DashBetaWaitlistRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/basecamp-style-reviews": {
      id: "/_dash/basecamp-style-reviews";
      path: "/basecamp-style-reviews";
      fullPath: "/basecamp-style-reviews";
      preLoaderRoute: typeof DashBasecampStyleReviewsRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/basecamp-run-inspector": {
      id: "/_dash/basecamp-run-inspector";
      path: "/basecamp-run-inspector";
      fullPath: "/basecamp-run-inspector";
      preLoaderRoute: typeof DashBasecampRunInspectorRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/basecamp": {
      id: "/_dash/basecamp";
      path: "/basecamp";
      fullPath: "/basecamp";
      preLoaderRoute: typeof DashBasecampRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/audio": {
      id: "/_dash/audio";
      path: "/audio";
      fullPath: "/audio";
      preLoaderRoute: typeof DashAudioRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/ai-edits": {
      id: "/_dash/ai-edits";
      path: "/ai-edits";
      fullPath: "/ai-edits";
      preLoaderRoute: typeof DashAiEditsRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/ai-edit-tool": {
      id: "/_dash/ai-edit-tool";
      path: "/ai-edit-tool";
      fullPath: "/ai-edit-tool";
      preLoaderRoute: typeof DashAiEditToolRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/agave": {
      id: "/_dash/agave";
      path: "/agave";
      fullPath: "/agave";
      preLoaderRoute: typeof DashAgaveRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/actors": {
      id: "/_dash/actors";
      path: "/actors";
      fullPath: "/actors";
      preLoaderRoute: typeof DashActorsRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/videos/": {
      id: "/_dash/videos/";
      path: "/";
      fullPath: "/videos/";
      preLoaderRoute: typeof DashVideosIndexRouteImport;
      parentRoute: typeof DashVideosRoute;
    };
    "/_dash/users/": {
      id: "/_dash/users/";
      path: "/";
      fullPath: "/users/";
      preLoaderRoute: typeof DashUsersIndexRouteImport;
      parentRoute: typeof DashUsersRoute;
    };
    "/_dash/studio-edits/": {
      id: "/_dash/studio-edits/";
      path: "/";
      fullPath: "/studio-edits/";
      preLoaderRoute: typeof DashStudioEditsIndexRouteImport;
      parentRoute: typeof DashStudioEditsRoute;
    };
    "/_dash/session-replays/": {
      id: "/_dash/session-replays/";
      path: "/";
      fullPath: "/session-replays/";
      preLoaderRoute: typeof DashSessionReplaysIndexRouteImport;
      parentRoute: typeof DashSessionReplaysRoute;
    };
    "/_dash/projects/": {
      id: "/_dash/projects/";
      path: "/";
      fullPath: "/projects/";
      preLoaderRoute: typeof DashProjectsIndexRouteImport;
      parentRoute: typeof DashProjectsRoute;
    };
    "/_dash/organizations/": {
      id: "/_dash/organizations/";
      path: "/";
      fullPath: "/organizations/";
      preLoaderRoute: typeof DashOrganizationsIndexRouteImport;
      parentRoute: typeof DashOrganizationsRoute;
    };
    "/_dash/org-by-default/": {
      id: "/_dash/org-by-default/";
      path: "/org-by-default";
      fullPath: "/org-by-default";
      preLoaderRoute: typeof DashOrgByDefaultIndexRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/moderation/": {
      id: "/_dash/moderation/";
      path: "/";
      fullPath: "/moderation/";
      preLoaderRoute: typeof DashModerationIndexRouteImport;
      parentRoute: typeof DashModerationRoute;
    };
    "/_dash/mcp/": {
      id: "/_dash/mcp/";
      path: "/";
      fullPath: "/mcp/";
      preLoaderRoute: typeof DashMcpIndexRouteImport;
      parentRoute: typeof DashMcpRoute;
    };
    "/_dash/jerboa-editor-session/": {
      id: "/_dash/jerboa-editor-session/";
      path: "/";
      fullPath: "/jerboa-editor-session/";
      preLoaderRoute: typeof DashJerboaEditorSessionIndexRouteImport;
      parentRoute: typeof DashJerboaEditorSessionRoute;
    };
    "/_dash/jerboa-codec-report/": {
      id: "/_dash/jerboa-codec-report/";
      path: "/";
      fullPath: "/jerboa-codec-report/";
      preLoaderRoute: typeof DashJerboaCodecReportIndexRouteImport;
      parentRoute: typeof DashJerboaCodecReportRoute;
    };
    "/_dash/jerboa-client-preview/": {
      id: "/_dash/jerboa-client-preview/";
      path: "/";
      fullPath: "/jerboa-client-preview/";
      preLoaderRoute: typeof DashJerboaClientPreviewIndexRouteImport;
      parentRoute: typeof DashJerboaClientPreviewRoute;
    };
    "/_dash/jerboa-client-network-load/": {
      id: "/_dash/jerboa-client-network-load/";
      path: "/";
      fullPath: "/jerboa-client-network-load/";
      preLoaderRoute: typeof DashJerboaClientNetworkLoadIndexRouteImport;
      parentRoute: typeof DashJerboaClientNetworkLoadRoute;
    };
    "/_dash/jerboa-client-export/": {
      id: "/_dash/jerboa-client-export/";
      path: "/";
      fullPath: "/jerboa-client-export/";
      preLoaderRoute: typeof DashJerboaClientExportIndexRouteImport;
      parentRoute: typeof DashJerboaClientExportRoute;
    };
    "/_dash/jerboa-client-error/": {
      id: "/_dash/jerboa-client-error/";
      path: "/";
      fullPath: "/jerboa-client-error/";
      preLoaderRoute: typeof DashJerboaClientErrorIndexRouteImport;
      parentRoute: typeof DashJerboaClientErrorRoute;
    };
    "/_dash/credits/": {
      id: "/_dash/credits/";
      path: "/";
      fullPath: "/credits/";
      preLoaderRoute: typeof DashCreditsIndexRouteImport;
      parentRoute: typeof DashCreditsRoute;
    };
    "/_dash/creator-styles/": {
      id: "/_dash/creator-styles/";
      path: "/";
      fullPath: "/creator-styles/";
      preLoaderRoute: typeof DashCreatorStylesIndexRouteImport;
      parentRoute: typeof DashCreatorStylesRoute;
    };
    "/_dash/cloudflare-redirects/": {
      id: "/_dash/cloudflare-redirects/";
      path: "/";
      fullPath: "/cloudflare-redirects/";
      preLoaderRoute: typeof DashCloudflareRedirectsIndexRouteImport;
      parentRoute: typeof DashCloudflareRedirectsRoute;
    };
    "/_dash/caption-templates/": {
      id: "/_dash/caption-templates/";
      path: "/";
      fullPath: "/caption-templates/";
      preLoaderRoute: typeof DashCaptionTemplatesIndexRouteImport;
      parentRoute: typeof DashCaptionTemplatesRoute;
    };
    "/_dash/capcode/": {
      id: "/_dash/capcode/";
      path: "/";
      fullPath: "/capcode/";
      preLoaderRoute: typeof DashCapcodeIndexRouteImport;
      parentRoute: typeof DashCapcodeRoute;
    };
    "/_dash/audio/": {
      id: "/_dash/audio/";
      path: "/";
      fullPath: "/audio/";
      preLoaderRoute: typeof DashAudioIndexRouteImport;
      parentRoute: typeof DashAudioRoute;
    };
    "/_dash/ai-edits/": {
      id: "/_dash/ai-edits/";
      path: "/";
      fullPath: "/ai-edits/";
      preLoaderRoute: typeof DashAiEditsIndexRouteImport;
      parentRoute: typeof DashAiEditsRoute;
    };
    "/_dash/ai-edit-tool/": {
      id: "/_dash/ai-edit-tool/";
      path: "/";
      fullPath: "/ai-edit-tool/";
      preLoaderRoute: typeof DashAiEditToolIndexRouteImport;
      parentRoute: typeof DashAiEditToolRoute;
    };
    "/_dash/actors/": {
      id: "/_dash/actors/";
      path: "/";
      fullPath: "/actors/";
      preLoaderRoute: typeof DashActorsIndexRouteImport;
      parentRoute: typeof DashActorsRoute;
    };
    "/_dash/videos/evals": {
      id: "/_dash/videos/evals";
      path: "/evals";
      fullPath: "/videos/evals";
      preLoaderRoute: typeof DashVideosEvalsRouteImport;
      parentRoute: typeof DashVideosRoute;
    };
    "/_dash/videos/bookmarked": {
      id: "/_dash/videos/bookmarked";
      path: "/bookmarked";
      fullPath: "/videos/bookmarked";
      preLoaderRoute: typeof DashVideosBookmarkedRouteImport;
      parentRoute: typeof DashVideosRoute;
    };
    "/_dash/users/internal-test-accounts": {
      id: "/_dash/users/internal-test-accounts";
      path: "/internal-test-accounts";
      fullPath: "/users/internal-test-accounts";
      preLoaderRoute: typeof DashUsersInternalTestAccountsRouteImport;
      parentRoute: typeof DashUsersRoute;
    };
    "/_dash/users/internal-accounts": {
      id: "/_dash/users/internal-accounts";
      path: "/internal-accounts";
      fullPath: "/users/internal-accounts";
      preLoaderRoute: typeof DashUsersInternalAccountsRouteImport;
      parentRoute: typeof DashUsersRoute;
    };
    "/_dash/session-replays/$replayId": {
      id: "/_dash/session-replays/$replayId";
      path: "/$replayId";
      fullPath: "/session-replays/$replayId";
      preLoaderRoute: typeof DashSessionReplaysReplayIdRouteImport;
      parentRoute: typeof DashSessionReplaysRoute;
    };
    "/_dash/review-feedback/$feedbackId": {
      id: "/_dash/review-feedback/$feedbackId";
      path: "/review-feedback/$feedbackId";
      fullPath: "/review-feedback/$feedbackId";
      preLoaderRoute: typeof DashReviewFeedbackFeedbackIdRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/projects/tesseract": {
      id: "/_dash/projects/tesseract";
      path: "/tesseract";
      fullPath: "/projects/tesseract";
      preLoaderRoute: typeof DashProjectsTesseractRouteImport;
      parentRoute: typeof DashProjectsRoute;
    };
    "/_dash/projects/search": {
      id: "/_dash/projects/search";
      path: "/search";
      fullPath: "/projects/search";
      preLoaderRoute: typeof DashProjectsSearchRouteImport;
      parentRoute: typeof DashProjectsRoute;
    };
    "/_dash/projects/chats": {
      id: "/_dash/projects/chats";
      path: "/chats";
      fullPath: "/projects/chats";
      preLoaderRoute: typeof DashProjectsChatsRouteImport;
      parentRoute: typeof DashProjectsRoute;
    };
    "/_dash/projects/animation-library": {
      id: "/_dash/projects/animation-library";
      path: "/animation-library";
      fullPath: "/projects/animation-library";
      preLoaderRoute: typeof DashProjectsAnimationLibraryRouteImport;
      parentRoute: typeof DashProjectsRoute;
    };
    "/_dash/projects/$projectId": {
      id: "/_dash/projects/$projectId";
      path: "/$projectId";
      fullPath: "/projects/$projectId";
      preLoaderRoute: typeof DashProjectsProjectIdRouteImport;
      parentRoute: typeof DashProjectsRoute;
    };
    "/_dash/ltv/meta-send-audit": {
      id: "/_dash/ltv/meta-send-audit";
      path: "/meta-send-audit";
      fullPath: "/ltv/meta-send-audit";
      preLoaderRoute: typeof DashLtvMetaSendAuditRouteImport;
      parentRoute: typeof DashLtvRoute;
    };
    "/_dash/ltv/appsflyer-send-audit": {
      id: "/_dash/ltv/appsflyer-send-audit";
      path: "/appsflyer-send-audit";
      fullPath: "/ltv/appsflyer-send-audit";
      preLoaderRoute: typeof DashLtvAppsflyerSendAuditRouteImport;
      parentRoute: typeof DashLtvRoute;
    };
    "/_dash/jerboa/rendering-results": {
      id: "/_dash/jerboa/rendering-results";
      path: "/rendering-results";
      fullPath: "/jerboa/rendering-results";
      preLoaderRoute: typeof DashJerboaRenderingResultsRouteImport;
      parentRoute: typeof DashJerboaRoute;
    };
    "/_dash/jerboa/ai-edit-fx-shadowing": {
      id: "/_dash/jerboa/ai-edit-fx-shadowing";
      path: "/ai-edit-fx-shadowing";
      fullPath: "/jerboa/ai-edit-fx-shadowing";
      preLoaderRoute: typeof DashJerboaAiEditFxShadowingRouteImport;
      parentRoute: typeof DashJerboaRoute;
    };
    "/_dash/jerboa-editor-session/$id": {
      id: "/_dash/jerboa-editor-session/$id";
      path: "/$id";
      fullPath: "/jerboa-editor-session/$id";
      preLoaderRoute: typeof DashJerboaEditorSessionIdRouteImport;
      parentRoute: typeof DashJerboaEditorSessionRoute;
    };
    "/_dash/jerboa-codec-report/$id": {
      id: "/_dash/jerboa-codec-report/$id";
      path: "/$id";
      fullPath: "/jerboa-codec-report/$id";
      preLoaderRoute: typeof DashJerboaCodecReportIdRouteImport;
      parentRoute: typeof DashJerboaCodecReportRoute;
    };
    "/_dash/jerboa-client-preview/$id": {
      id: "/_dash/jerboa-client-preview/$id";
      path: "/$id";
      fullPath: "/jerboa-client-preview/$id";
      preLoaderRoute: typeof DashJerboaClientPreviewIdRouteImport;
      parentRoute: typeof DashJerboaClientPreviewRoute;
    };
    "/_dash/jerboa-client-network-load/$id": {
      id: "/_dash/jerboa-client-network-load/$id";
      path: "/$id";
      fullPath: "/jerboa-client-network-load/$id";
      preLoaderRoute: typeof DashJerboaClientNetworkLoadIdRouteImport;
      parentRoute: typeof DashJerboaClientNetworkLoadRoute;
    };
    "/_dash/jerboa-client-export/$id": {
      id: "/_dash/jerboa-client-export/$id";
      path: "/$id";
      fullPath: "/jerboa-client-export/$id";
      preLoaderRoute: typeof DashJerboaClientExportIdRouteImport;
      parentRoute: typeof DashJerboaClientExportRoute;
    };
    "/_dash/jerboa-client-error/$id": {
      id: "/_dash/jerboa-client-error/$id";
      path: "/$id";
      fullPath: "/jerboa-client-error/$id";
      preLoaderRoute: typeof DashJerboaClientErrorIdRouteImport;
      parentRoute: typeof DashJerboaClientErrorRoute;
    };
    "/_dash/creator-styles/$styleId": {
      id: "/_dash/creator-styles/$styleId";
      path: "/$styleId";
      fullPath: "/creator-styles/$styleId";
      preLoaderRoute: typeof DashCreatorStylesStyleIdRouteImport;
      parentRoute: typeof DashCreatorStylesRoute;
    };
    "/_dash/caption-templates/$templateId": {
      id: "/_dash/caption-templates/$templateId";
      path: "/$templateId";
      fullPath: "/caption-templates/$templateId";
      preLoaderRoute: typeof DashCaptionTemplatesTemplateIdRouteImport;
      parentRoute: typeof DashCaptionTemplatesRoute;
    };
    "/_dash/capcode/review-feedback": {
      id: "/_dash/capcode/review-feedback";
      path: "/review-feedback";
      fullPath: "/capcode/review-feedback";
      preLoaderRoute: typeof DashCapcodeReviewFeedbackRouteImport;
      parentRoute: typeof DashCapcodeRoute;
    };
    "/_dash/basecamp/evals": {
      id: "/_dash/basecamp/evals";
      path: "/evals";
      fullPath: "/basecamp/evals";
      preLoaderRoute: typeof DashBasecampEvalsRouteImport;
      parentRoute: typeof DashBasecampRoute;
    };
    "/_dash/ai-edits/prompt-to-video": {
      id: "/_dash/ai-edits/prompt-to-video";
      path: "/prompt-to-video";
      fullPath: "/ai-edits/prompt-to-video";
      preLoaderRoute: typeof DashAiEditsPromptToVideoRouteImport;
      parentRoute: typeof DashAiEditsRoute;
    };
    "/_dash/ai-edits/long-to-short": {
      id: "/_dash/ai-edits/long-to-short";
      path: "/long-to-short";
      fullPath: "/ai-edits/long-to-short";
      preLoaderRoute: typeof DashAiEditsLongToShortRouteImport;
      parentRoute: typeof DashAiEditsRoute;
    };
    "/_dash/ai-edits/evals": {
      id: "/_dash/ai-edits/evals";
      path: "/evals";
      fullPath: "/ai-edits/evals";
      preLoaderRoute: typeof DashAiEditsEvalsRouteImport;
      parentRoute: typeof DashAiEditsRoute;
    };
    "/_dash/ai-edits/cactus-tools": {
      id: "/_dash/ai-edits/cactus-tools";
      path: "/cactus-tools";
      fullPath: "/ai-edits/cactus-tools";
      preLoaderRoute: typeof DashAiEditsCactusToolsRouteImport;
      parentRoute: typeof DashAiEditsRoute;
    };
    "/_dash/ai-edits/all": {
      id: "/_dash/ai-edits/all";
      path: "/all";
      fullPath: "/ai-edits/all";
      preLoaderRoute: typeof DashAiEditsAllRouteImport;
      parentRoute: typeof DashAiEditsRoute;
    };
    "/_dash/ai-edits/agave-shadows": {
      id: "/_dash/ai-edits/agave-shadows";
      path: "/agave-shadows";
      fullPath: "/ai-edits/agave-shadows";
      preLoaderRoute: typeof DashAiEditsAgaveShadowsRouteImport;
      parentRoute: typeof DashAiEditsRoute;
    };
    "/_dash/ai-edits/agave-operations": {
      id: "/_dash/ai-edits/agave-operations";
      path: "/agave-operations";
      fullPath: "/ai-edits/agave-operations";
      preLoaderRoute: typeof DashAiEditsAgaveOperationsRouteImport;
      parentRoute: typeof DashAiEditsRoute;
    };
    "/_dash/ai-edits/agave-operation-graph": {
      id: "/_dash/ai-edits/agave-operation-graph";
      path: "/agave-operation-graph";
      fullPath: "/ai-edits/agave-operation-graph";
      preLoaderRoute: typeof DashAiEditsAgaveOperationGraphRouteImport;
      parentRoute: typeof DashAiEditsRoute;
    };
    "/_dash/ai-edits/$operationId": {
      id: "/_dash/ai-edits/$operationId";
      path: "/$operationId";
      fullPath: "/ai-edits/$operationId";
      preLoaderRoute: typeof DashAiEditsOperationIdRouteImport;
      parentRoute: typeof DashAiEditsRoute;
    };
    "/_dash/videos/segment-eval/": {
      id: "/_dash/videos/segment-eval/";
      path: "/segment-eval";
      fullPath: "/videos/segment-eval";
      preLoaderRoute: typeof DashVideosSegmentEvalIndexRouteImport;
      parentRoute: typeof DashVideosRoute;
    };
    "/_dash/videos/evals/": {
      id: "/_dash/videos/evals/";
      path: "/";
      fullPath: "/videos/evals/";
      preLoaderRoute: typeof DashVideosEvalsIndexRouteImport;
      parentRoute: typeof DashVideosEvalsRoute;
    };
    "/_dash/jerboa/rendering-results/": {
      id: "/_dash/jerboa/rendering-results/";
      path: "/";
      fullPath: "/jerboa/rendering-results/";
      preLoaderRoute: typeof DashJerboaRenderingResultsIndexRouteImport;
      parentRoute: typeof DashJerboaRenderingResultsRoute;
    };
    "/_dash/jerboa/ai-edit-fx-shadowing/": {
      id: "/_dash/jerboa/ai-edit-fx-shadowing/";
      path: "/";
      fullPath: "/jerboa/ai-edit-fx-shadowing/";
      preLoaderRoute: typeof DashJerboaAiEditFxShadowingIndexRouteImport;
      parentRoute: typeof DashJerboaAiEditFxShadowingRoute;
    };
    "/_dash/cloudflare-redirects/remove/": {
      id: "/_dash/cloudflare-redirects/remove/";
      path: "/remove";
      fullPath: "/cloudflare-redirects/remove";
      preLoaderRoute: typeof DashCloudflareRedirectsRemoveIndexRouteImport;
      parentRoute: typeof DashCloudflareRedirectsRoute;
    };
    "/_dash/capcode/reviews/": {
      id: "/_dash/capcode/reviews/";
      path: "/reviews";
      fullPath: "/capcode/reviews";
      preLoaderRoute: typeof DashCapcodeReviewsIndexRouteImport;
      parentRoute: typeof DashCapcodeRoute;
    };
    "/_dash/basecamp/user-outputs/": {
      id: "/_dash/basecamp/user-outputs/";
      path: "/user-outputs";
      fullPath: "/basecamp/user-outputs";
      preLoaderRoute: typeof DashBasecampUserOutputsIndexRouteImport;
      parentRoute: typeof DashBasecampRoute;
    };
    "/_dash/basecamp/evals/": {
      id: "/_dash/basecamp/evals/";
      path: "/";
      fullPath: "/basecamp/evals/";
      preLoaderRoute: typeof DashBasecampEvalsIndexRouteImport;
      parentRoute: typeof DashBasecampEvalsRoute;
    };
    "/_dash/ai-edits/evals/": {
      id: "/_dash/ai-edits/evals/";
      path: "/";
      fullPath: "/ai-edits/evals/";
      preLoaderRoute: typeof DashAiEditsEvalsIndexRouteImport;
      parentRoute: typeof DashAiEditsEvalsRoute;
    };
    "/_dash/ai-edits/cactus-tools/": {
      id: "/_dash/ai-edits/cactus-tools/";
      path: "/";
      fullPath: "/ai-edits/cactus-tools/";
      preLoaderRoute: typeof DashAiEditsCactusToolsIndexRouteImport;
      parentRoute: typeof DashAiEditsCactusToolsRoute;
    };
    "/_dash/videos/view/$videoId": {
      id: "/_dash/videos/view/$videoId";
      path: "/view/$videoId";
      fullPath: "/videos/view/$videoId";
      preLoaderRoute: typeof DashVideosViewVideoIdRouteImport;
      parentRoute: typeof DashVideosRoute;
    };
    "/_dash/videos/segment-eval/results": {
      id: "/_dash/videos/segment-eval/results";
      path: "/segment-eval/results";
      fullPath: "/videos/segment-eval/results";
      preLoaderRoute: typeof DashVideosSegmentEvalResultsRouteImport;
      parentRoute: typeof DashVideosRoute;
    };
    "/_dash/videos/segment-eval/admin": {
      id: "/_dash/videos/segment-eval/admin";
      path: "/segment-eval/admin";
      fullPath: "/videos/segment-eval/admin";
      preLoaderRoute: typeof DashVideosSegmentEvalAdminRouteImport;
      parentRoute: typeof DashVideosRoute;
    };
    "/_dash/videos/evals/$testId": {
      id: "/_dash/videos/evals/$testId";
      path: "/$testId";
      fullPath: "/videos/evals/$testId";
      preLoaderRoute: typeof DashVideosEvalsTestIdRouteImport;
      parentRoute: typeof DashVideosEvalsRoute;
    };
    "/_dash/users/view/$userId": {
      id: "/_dash/users/view/$userId";
      path: "/view/$userId";
      fullPath: "/users/view/$userId";
      preLoaderRoute: typeof DashUsersViewUserIdRouteImport;
      parentRoute: typeof DashUsersRoute;
    };
    "/_dash/users/undelete-account/$userId": {
      id: "/_dash/users/undelete-account/$userId";
      path: "/undelete-account/$userId";
      fullPath: "/users/undelete-account/$userId";
      preLoaderRoute: typeof DashUsersUndeleteAccountUserIdRouteImport;
      parentRoute: typeof DashUsersRoute;
    };
    "/_dash/users/force-sign-out/$userId": {
      id: "/_dash/users/force-sign-out/$userId";
      path: "/force-sign-out/$userId";
      fullPath: "/users/force-sign-out/$userId";
      preLoaderRoute: typeof DashUsersForceSignOutUserIdRouteImport;
      parentRoute: typeof DashUsersRoute;
    };
    "/_dash/users/delete-account/$userId": {
      id: "/_dash/users/delete-account/$userId";
      path: "/delete-account/$userId";
      fullPath: "/users/delete-account/$userId";
      preLoaderRoute: typeof DashUsersDeleteAccountUserIdRouteImport;
      parentRoute: typeof DashUsersRoute;
    };
    "/_dash/studio-edits/view/$videoId": {
      id: "/_dash/studio-edits/view/$videoId";
      path: "/view/$videoId";
      fullPath: "/studio-edits/view/$videoId";
      preLoaderRoute: typeof DashStudioEditsViewVideoIdRouteImport;
      parentRoute: typeof DashStudioEditsRoute;
    };
    "/_dash/organizations/view/$orgId": {
      id: "/_dash/organizations/view/$orgId";
      path: "/view/$orgId";
      fullPath: "/organizations/view/$orgId";
      preLoaderRoute: typeof DashOrganizationsViewOrgIdRouteImport;
      parentRoute: typeof DashOrganizationsRoute;
    };
    "/_dash/mcp/skills/$skill": {
      id: "/_dash/mcp/skills/$skill";
      path: "/skills/$skill";
      fullPath: "/mcp/skills/$skill";
      preLoaderRoute: typeof DashMcpSkillsSkillRouteImport;
      parentRoute: typeof DashMcpRoute;
    };
    "/_dash/linkedin-skills/users/$userId": {
      id: "/_dash/linkedin-skills/users/$userId";
      path: "/users/$userId";
      fullPath: "/linkedin-skills/users/$userId";
      preLoaderRoute: typeof DashLinkedinSkillsUsersUserIdRouteImport;
      parentRoute: typeof DashLinkedinSkillsRoute;
    };
    "/_dash/jerboa/rendering-results/$resultId": {
      id: "/_dash/jerboa/rendering-results/$resultId";
      path: "/$resultId";
      fullPath: "/jerboa/rendering-results/$resultId";
      preLoaderRoute: typeof DashJerboaRenderingResultsResultIdRouteImport;
      parentRoute: typeof DashJerboaRenderingResultsRoute;
    };
    "/_dash/jerboa/ai-edit-fx-shadowing/$resultId": {
      id: "/_dash/jerboa/ai-edit-fx-shadowing/$resultId";
      path: "/$resultId";
      fullPath: "/jerboa/ai-edit-fx-shadowing/$resultId";
      preLoaderRoute: typeof DashJerboaAiEditFxShadowingResultIdRouteImport;
      parentRoute: typeof DashJerboaAiEditFxShadowingRoute;
    };
    "/_dash/charges/users/$userId": {
      id: "/_dash/charges/users/$userId";
      path: "/charges/users/$userId";
      fullPath: "/charges/users/$userId";
      preLoaderRoute: typeof DashChargesUsersUserIdRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/charges/organizations/$orgId": {
      id: "/_dash/charges/organizations/$orgId";
      path: "/charges/organizations/$orgId";
      fullPath: "/charges/organizations/$orgId";
      preLoaderRoute: typeof DashChargesOrganizationsOrgIdRouteImport;
      parentRoute: typeof DashRoute;
    };
    "/_dash/capcode/reviews/$docId": {
      id: "/_dash/capcode/reviews/$docId";
      path: "/reviews/$docId";
      fullPath: "/capcode/reviews/$docId";
      preLoaderRoute: typeof DashCapcodeReviewsDocIdRouteImport;
      parentRoute: typeof DashCapcodeRoute;
    };
    "/_dash/basecamp/evals/$comparisonId": {
      id: "/_dash/basecamp/evals/$comparisonId";
      path: "/$comparisonId";
      fullPath: "/basecamp/evals/$comparisonId";
      preLoaderRoute: typeof DashBasecampEvalsComparisonIdRouteImport;
      parentRoute: typeof DashBasecampEvalsRoute;
    };
    "/_dash/ai-edits/evals/$runId": {
      id: "/_dash/ai-edits/evals/$runId";
      path: "/$runId";
      fullPath: "/ai-edits/evals/$runId";
      preLoaderRoute: typeof DashAiEditsEvalsRunIdRouteImport;
      parentRoute: typeof DashAiEditsEvalsRoute;
    };
    "/_dash/ai-edits/agave-shadow-renders/$shadowRenderId": {
      id: "/_dash/ai-edits/agave-shadow-renders/$shadowRenderId";
      path: "/agave-shadow-renders/$shadowRenderId";
      fullPath: "/ai-edits/agave-shadow-renders/$shadowRenderId";
      preLoaderRoute: typeof DashAiEditsAgaveShadowRendersShadowRenderIdRouteImport;
      parentRoute: typeof DashAiEditsRoute;
    };
    "/_dash/ai-edit-tool/sst/$shotStyleId": {
      id: "/_dash/ai-edit-tool/sst/$shotStyleId";
      path: "/sst/$shotStyleId";
      fullPath: "/ai-edit-tool/sst/$shotStyleId";
      preLoaderRoute: typeof DashAiEditToolSstShotStyleIdRouteImport;
      parentRoute: typeof DashAiEditToolRoute;
    };
    "/_dash/ai-edit-tool/new/vst": {
      id: "/_dash/ai-edit-tool/new/vst";
      path: "/new/vst";
      fullPath: "/ai-edit-tool/new/vst";
      preLoaderRoute: typeof DashAiEditToolNewVstRouteImport;
      parentRoute: typeof DashAiEditToolRoute;
    };
    "/_dash/videos/evals/dpo/": {
      id: "/_dash/videos/evals/dpo/";
      path: "/dpo";
      fullPath: "/videos/evals/dpo";
      preLoaderRoute: typeof DashVideosEvalsDpoIndexRouteImport;
      parentRoute: typeof DashVideosEvalsRoute;
    };
    "/_dash/videos/evals/dpo-review/": {
      id: "/_dash/videos/evals/dpo-review/";
      path: "/dpo-review";
      fullPath: "/videos/evals/dpo-review";
      preLoaderRoute: typeof DashVideosEvalsDpoReviewIndexRouteImport;
      parentRoute: typeof DashVideosEvalsRoute;
    };
    "/_dash/videos/evals/$testId/": {
      id: "/_dash/videos/evals/$testId/";
      path: "/";
      fullPath: "/videos/evals/$testId/";
      preLoaderRoute: typeof DashVideosEvalsTestIdIndexRouteImport;
      parentRoute: typeof DashVideosEvalsTestIdRoute;
    };
    "/_dash/videos/evals/dpo/$testId": {
      id: "/_dash/videos/evals/dpo/$testId";
      path: "/dpo/$testId";
      fullPath: "/videos/evals/dpo/$testId";
      preLoaderRoute: typeof DashVideosEvalsDpoTestIdRouteImport;
      parentRoute: typeof DashVideosEvalsRoute;
    };
    "/_dash/videos/evals/dpo-review/$panelId": {
      id: "/_dash/videos/evals/dpo-review/$panelId";
      path: "/dpo-review/$panelId";
      fullPath: "/videos/evals/dpo-review/$panelId";
      preLoaderRoute: typeof DashVideosEvalsDpoReviewPanelIdRouteImport;
      parentRoute: typeof DashVideosEvalsRoute;
    };
    "/_dash/videos/evals/$testId/results": {
      id: "/_dash/videos/evals/$testId/results";
      path: "/results";
      fullPath: "/videos/evals/$testId/results";
      preLoaderRoute: typeof DashVideosEvalsTestIdResultsRouteImport;
      parentRoute: typeof DashVideosEvalsTestIdRoute;
    };
    "/_dash/videos/evals/$testId/rank": {
      id: "/_dash/videos/evals/$testId/rank";
      path: "/rank";
      fullPath: "/videos/evals/$testId/rank";
      preLoaderRoute: typeof DashVideosEvalsTestIdRankRouteImport;
      parentRoute: typeof DashVideosEvalsTestIdRoute;
    };
    "/_dash/ai-edits/evals/pairwise/$comparisonId": {
      id: "/_dash/ai-edits/evals/pairwise/$comparisonId";
      path: "/pairwise/$comparisonId";
      fullPath: "/ai-edits/evals/pairwise/$comparisonId";
      preLoaderRoute: typeof DashAiEditsEvalsPairwiseComparisonIdRouteImport;
      parentRoute: typeof DashAiEditsEvalsRoute;
    };
    "/_dash/ai-edits/evals/comparisons/$comparisonId": {
      id: "/_dash/ai-edits/evals/comparisons/$comparisonId";
      path: "/comparisons/$comparisonId";
      fullPath: "/ai-edits/evals/comparisons/$comparisonId";
      preLoaderRoute: typeof DashAiEditsEvalsComparisonsComparisonIdRouteImport;
      parentRoute: typeof DashAiEditsEvalsRoute;
    };
    "/_dash/ai-edits/cactus-tools/$workflowIdentifier/$workflowRunId": {
      id: "/_dash/ai-edits/cactus-tools/$workflowIdentifier/$workflowRunId";
      path: "/$workflowIdentifier/$workflowRunId";
      fullPath: "/ai-edits/cactus-tools/$workflowIdentifier/$workflowRunId";
      preLoaderRoute: typeof DashAiEditsCactusToolsWorkflowIdentifierWorkflowRunIdRouteImport;
      parentRoute: typeof DashAiEditsCactusToolsRoute;
    };
    "/_dash/ai-edit-tool/new/sst/$videoStyleId": {
      id: "/_dash/ai-edit-tool/new/sst/$videoStyleId";
      path: "/new/sst/$videoStyleId";
      fullPath: "/ai-edit-tool/new/sst/$videoStyleId";
      preLoaderRoute: typeof DashAiEditToolNewSstVideoStyleIdRouteImport;
      parentRoute: typeof DashAiEditToolRoute;
    };
  }
}

interface DashActorsRouteChildren {
  DashActorsIndexRoute: typeof DashActorsIndexRoute;
}

const DashActorsRouteChildren: DashActorsRouteChildren = {
  DashActorsIndexRoute: DashActorsIndexRoute,
};

const DashActorsRouteWithChildren = DashActorsRoute._addFileChildren(
  DashActorsRouteChildren,
);

interface DashAiEditToolRouteChildren {
  DashAiEditToolIndexRoute: typeof DashAiEditToolIndexRoute;
  DashAiEditToolNewVstRoute: typeof DashAiEditToolNewVstRoute;
  DashAiEditToolSstShotStyleIdRoute: typeof DashAiEditToolSstShotStyleIdRoute;
  DashAiEditToolNewSstVideoStyleIdRoute: typeof DashAiEditToolNewSstVideoStyleIdRoute;
}

const DashAiEditToolRouteChildren: DashAiEditToolRouteChildren = {
  DashAiEditToolIndexRoute: DashAiEditToolIndexRoute,
  DashAiEditToolNewVstRoute: DashAiEditToolNewVstRoute,
  DashAiEditToolSstShotStyleIdRoute: DashAiEditToolSstShotStyleIdRoute,
  DashAiEditToolNewSstVideoStyleIdRoute: DashAiEditToolNewSstVideoStyleIdRoute,
};

const DashAiEditToolRouteWithChildren = DashAiEditToolRoute._addFileChildren(
  DashAiEditToolRouteChildren,
);

interface DashAiEditsCactusToolsRouteChildren {
  DashAiEditsCactusToolsIndexRoute: typeof DashAiEditsCactusToolsIndexRoute;
  DashAiEditsCactusToolsWorkflowIdentifierWorkflowRunIdRoute: typeof DashAiEditsCactusToolsWorkflowIdentifierWorkflowRunIdRoute;
}

const DashAiEditsCactusToolsRouteChildren: DashAiEditsCactusToolsRouteChildren =
  {
    DashAiEditsCactusToolsIndexRoute: DashAiEditsCactusToolsIndexRoute,
    DashAiEditsCactusToolsWorkflowIdentifierWorkflowRunIdRoute:
      DashAiEditsCactusToolsWorkflowIdentifierWorkflowRunIdRoute,
  };

const DashAiEditsCactusToolsRouteWithChildren =
  DashAiEditsCactusToolsRoute._addFileChildren(
    DashAiEditsCactusToolsRouteChildren,
  );

interface DashAiEditsEvalsRouteChildren {
  DashAiEditsEvalsRunIdRoute: typeof DashAiEditsEvalsRunIdRoute;
  DashAiEditsEvalsIndexRoute: typeof DashAiEditsEvalsIndexRoute;
  DashAiEditsEvalsComparisonsComparisonIdRoute: typeof DashAiEditsEvalsComparisonsComparisonIdRoute;
  DashAiEditsEvalsPairwiseComparisonIdRoute: typeof DashAiEditsEvalsPairwiseComparisonIdRoute;
}

const DashAiEditsEvalsRouteChildren: DashAiEditsEvalsRouteChildren = {
  DashAiEditsEvalsRunIdRoute: DashAiEditsEvalsRunIdRoute,
  DashAiEditsEvalsIndexRoute: DashAiEditsEvalsIndexRoute,
  DashAiEditsEvalsComparisonsComparisonIdRoute:
    DashAiEditsEvalsComparisonsComparisonIdRoute,
  DashAiEditsEvalsPairwiseComparisonIdRoute:
    DashAiEditsEvalsPairwiseComparisonIdRoute,
};

const DashAiEditsEvalsRouteWithChildren =
  DashAiEditsEvalsRoute._addFileChildren(DashAiEditsEvalsRouteChildren);

interface DashAiEditsRouteChildren {
  DashAiEditsOperationIdRoute: typeof DashAiEditsOperationIdRoute;
  DashAiEditsAgaveOperationGraphRoute: typeof DashAiEditsAgaveOperationGraphRoute;
  DashAiEditsAgaveOperationsRoute: typeof DashAiEditsAgaveOperationsRoute;
  DashAiEditsAgaveShadowsRoute: typeof DashAiEditsAgaveShadowsRoute;
  DashAiEditsAllRoute: typeof DashAiEditsAllRoute;
  DashAiEditsCactusToolsRoute: typeof DashAiEditsCactusToolsRouteWithChildren;
  DashAiEditsEvalsRoute: typeof DashAiEditsEvalsRouteWithChildren;
  DashAiEditsLongToShortRoute: typeof DashAiEditsLongToShortRoute;
  DashAiEditsPromptToVideoRoute: typeof DashAiEditsPromptToVideoRoute;
  DashAiEditsIndexRoute: typeof DashAiEditsIndexRoute;
  DashAiEditsAgaveShadowRendersShadowRenderIdRoute: typeof DashAiEditsAgaveShadowRendersShadowRenderIdRoute;
}

const DashAiEditsRouteChildren: DashAiEditsRouteChildren = {
  DashAiEditsOperationIdRoute: DashAiEditsOperationIdRoute,
  DashAiEditsAgaveOperationGraphRoute: DashAiEditsAgaveOperationGraphRoute,
  DashAiEditsAgaveOperationsRoute: DashAiEditsAgaveOperationsRoute,
  DashAiEditsAgaveShadowsRoute: DashAiEditsAgaveShadowsRoute,
  DashAiEditsAllRoute: DashAiEditsAllRoute,
  DashAiEditsCactusToolsRoute: DashAiEditsCactusToolsRouteWithChildren,
  DashAiEditsEvalsRoute: DashAiEditsEvalsRouteWithChildren,
  DashAiEditsLongToShortRoute: DashAiEditsLongToShortRoute,
  DashAiEditsPromptToVideoRoute: DashAiEditsPromptToVideoRoute,
  DashAiEditsIndexRoute: DashAiEditsIndexRoute,
  DashAiEditsAgaveShadowRendersShadowRenderIdRoute:
    DashAiEditsAgaveShadowRendersShadowRenderIdRoute,
};

const DashAiEditsRouteWithChildren = DashAiEditsRoute._addFileChildren(
  DashAiEditsRouteChildren,
);

interface DashAudioRouteChildren {
  DashAudioIndexRoute: typeof DashAudioIndexRoute;
}

const DashAudioRouteChildren: DashAudioRouteChildren = {
  DashAudioIndexRoute: DashAudioIndexRoute,
};

const DashAudioRouteWithChildren = DashAudioRoute._addFileChildren(
  DashAudioRouteChildren,
);

interface DashBasecampEvalsRouteChildren {
  DashBasecampEvalsComparisonIdRoute: typeof DashBasecampEvalsComparisonIdRoute;
  DashBasecampEvalsIndexRoute: typeof DashBasecampEvalsIndexRoute;
}

const DashBasecampEvalsRouteChildren: DashBasecampEvalsRouteChildren = {
  DashBasecampEvalsComparisonIdRoute: DashBasecampEvalsComparisonIdRoute,
  DashBasecampEvalsIndexRoute: DashBasecampEvalsIndexRoute,
};

const DashBasecampEvalsRouteWithChildren =
  DashBasecampEvalsRoute._addFileChildren(DashBasecampEvalsRouteChildren);

interface DashBasecampRouteChildren {
  DashBasecampEvalsRoute: typeof DashBasecampEvalsRouteWithChildren;
  DashBasecampUserOutputsIndexRoute: typeof DashBasecampUserOutputsIndexRoute;
}

const DashBasecampRouteChildren: DashBasecampRouteChildren = {
  DashBasecampEvalsRoute: DashBasecampEvalsRouteWithChildren,
  DashBasecampUserOutputsIndexRoute: DashBasecampUserOutputsIndexRoute,
};

const DashBasecampRouteWithChildren = DashBasecampRoute._addFileChildren(
  DashBasecampRouteChildren,
);

interface DashCapcodeRouteChildren {
  DashCapcodeReviewFeedbackRoute: typeof DashCapcodeReviewFeedbackRoute;
  DashCapcodeIndexRoute: typeof DashCapcodeIndexRoute;
  DashCapcodeReviewsDocIdRoute: typeof DashCapcodeReviewsDocIdRoute;
  DashCapcodeReviewsIndexRoute: typeof DashCapcodeReviewsIndexRoute;
}

const DashCapcodeRouteChildren: DashCapcodeRouteChildren = {
  DashCapcodeReviewFeedbackRoute: DashCapcodeReviewFeedbackRoute,
  DashCapcodeIndexRoute: DashCapcodeIndexRoute,
  DashCapcodeReviewsDocIdRoute: DashCapcodeReviewsDocIdRoute,
  DashCapcodeReviewsIndexRoute: DashCapcodeReviewsIndexRoute,
};

const DashCapcodeRouteWithChildren = DashCapcodeRoute._addFileChildren(
  DashCapcodeRouteChildren,
);

interface DashCaptionTemplatesRouteChildren {
  DashCaptionTemplatesTemplateIdRoute: typeof DashCaptionTemplatesTemplateIdRoute;
  DashCaptionTemplatesIndexRoute: typeof DashCaptionTemplatesIndexRoute;
}

const DashCaptionTemplatesRouteChildren: DashCaptionTemplatesRouteChildren = {
  DashCaptionTemplatesTemplateIdRoute: DashCaptionTemplatesTemplateIdRoute,
  DashCaptionTemplatesIndexRoute: DashCaptionTemplatesIndexRoute,
};

const DashCaptionTemplatesRouteWithChildren =
  DashCaptionTemplatesRoute._addFileChildren(DashCaptionTemplatesRouteChildren);

interface DashCloudflareRedirectsRouteChildren {
  DashCloudflareRedirectsIndexRoute: typeof DashCloudflareRedirectsIndexRoute;
  DashCloudflareRedirectsRemoveIndexRoute: typeof DashCloudflareRedirectsRemoveIndexRoute;
}

const DashCloudflareRedirectsRouteChildren: DashCloudflareRedirectsRouteChildren =
  {
    DashCloudflareRedirectsIndexRoute: DashCloudflareRedirectsIndexRoute,
    DashCloudflareRedirectsRemoveIndexRoute:
      DashCloudflareRedirectsRemoveIndexRoute,
  };

const DashCloudflareRedirectsRouteWithChildren =
  DashCloudflareRedirectsRoute._addFileChildren(
    DashCloudflareRedirectsRouteChildren,
  );

interface DashCreatorStylesRouteChildren {
  DashCreatorStylesStyleIdRoute: typeof DashCreatorStylesStyleIdRoute;
  DashCreatorStylesIndexRoute: typeof DashCreatorStylesIndexRoute;
}

const DashCreatorStylesRouteChildren: DashCreatorStylesRouteChildren = {
  DashCreatorStylesStyleIdRoute: DashCreatorStylesStyleIdRoute,
  DashCreatorStylesIndexRoute: DashCreatorStylesIndexRoute,
};

const DashCreatorStylesRouteWithChildren =
  DashCreatorStylesRoute._addFileChildren(DashCreatorStylesRouteChildren);

interface DashCreditsRouteChildren {
  DashCreditsIndexRoute: typeof DashCreditsIndexRoute;
}

const DashCreditsRouteChildren: DashCreditsRouteChildren = {
  DashCreditsIndexRoute: DashCreditsIndexRoute,
};

const DashCreditsRouteWithChildren = DashCreditsRoute._addFileChildren(
  DashCreditsRouteChildren,
);

interface DashJerboaAiEditFxShadowingRouteChildren {
  DashJerboaAiEditFxShadowingResultIdRoute: typeof DashJerboaAiEditFxShadowingResultIdRoute;
  DashJerboaAiEditFxShadowingIndexRoute: typeof DashJerboaAiEditFxShadowingIndexRoute;
}

const DashJerboaAiEditFxShadowingRouteChildren: DashJerboaAiEditFxShadowingRouteChildren =
  {
    DashJerboaAiEditFxShadowingResultIdRoute:
      DashJerboaAiEditFxShadowingResultIdRoute,
    DashJerboaAiEditFxShadowingIndexRoute:
      DashJerboaAiEditFxShadowingIndexRoute,
  };

const DashJerboaAiEditFxShadowingRouteWithChildren =
  DashJerboaAiEditFxShadowingRoute._addFileChildren(
    DashJerboaAiEditFxShadowingRouteChildren,
  );

interface DashJerboaRenderingResultsRouteChildren {
  DashJerboaRenderingResultsResultIdRoute: typeof DashJerboaRenderingResultsResultIdRoute;
  DashJerboaRenderingResultsIndexRoute: typeof DashJerboaRenderingResultsIndexRoute;
}

const DashJerboaRenderingResultsRouteChildren: DashJerboaRenderingResultsRouteChildren =
  {
    DashJerboaRenderingResultsResultIdRoute:
      DashJerboaRenderingResultsResultIdRoute,
    DashJerboaRenderingResultsIndexRoute: DashJerboaRenderingResultsIndexRoute,
  };

const DashJerboaRenderingResultsRouteWithChildren =
  DashJerboaRenderingResultsRoute._addFileChildren(
    DashJerboaRenderingResultsRouteChildren,
  );

interface DashJerboaRouteChildren {
  DashJerboaAiEditFxShadowingRoute: typeof DashJerboaAiEditFxShadowingRouteWithChildren;
  DashJerboaRenderingResultsRoute: typeof DashJerboaRenderingResultsRouteWithChildren;
}

const DashJerboaRouteChildren: DashJerboaRouteChildren = {
  DashJerboaAiEditFxShadowingRoute:
    DashJerboaAiEditFxShadowingRouteWithChildren,
  DashJerboaRenderingResultsRoute: DashJerboaRenderingResultsRouteWithChildren,
};

const DashJerboaRouteWithChildren = DashJerboaRoute._addFileChildren(
  DashJerboaRouteChildren,
);

interface DashJerboaClientErrorRouteChildren {
  DashJerboaClientErrorIdRoute: typeof DashJerboaClientErrorIdRoute;
  DashJerboaClientErrorIndexRoute: typeof DashJerboaClientErrorIndexRoute;
}

const DashJerboaClientErrorRouteChildren: DashJerboaClientErrorRouteChildren = {
  DashJerboaClientErrorIdRoute: DashJerboaClientErrorIdRoute,
  DashJerboaClientErrorIndexRoute: DashJerboaClientErrorIndexRoute,
};

const DashJerboaClientErrorRouteWithChildren =
  DashJerboaClientErrorRoute._addFileChildren(
    DashJerboaClientErrorRouteChildren,
  );

interface DashJerboaClientExportRouteChildren {
  DashJerboaClientExportIdRoute: typeof DashJerboaClientExportIdRoute;
  DashJerboaClientExportIndexRoute: typeof DashJerboaClientExportIndexRoute;
}

const DashJerboaClientExportRouteChildren: DashJerboaClientExportRouteChildren =
  {
    DashJerboaClientExportIdRoute: DashJerboaClientExportIdRoute,
    DashJerboaClientExportIndexRoute: DashJerboaClientExportIndexRoute,
  };

const DashJerboaClientExportRouteWithChildren =
  DashJerboaClientExportRoute._addFileChildren(
    DashJerboaClientExportRouteChildren,
  );

interface DashJerboaClientNetworkLoadRouteChildren {
  DashJerboaClientNetworkLoadIdRoute: typeof DashJerboaClientNetworkLoadIdRoute;
  DashJerboaClientNetworkLoadIndexRoute: typeof DashJerboaClientNetworkLoadIndexRoute;
}

const DashJerboaClientNetworkLoadRouteChildren: DashJerboaClientNetworkLoadRouteChildren =
  {
    DashJerboaClientNetworkLoadIdRoute: DashJerboaClientNetworkLoadIdRoute,
    DashJerboaClientNetworkLoadIndexRoute:
      DashJerboaClientNetworkLoadIndexRoute,
  };

const DashJerboaClientNetworkLoadRouteWithChildren =
  DashJerboaClientNetworkLoadRoute._addFileChildren(
    DashJerboaClientNetworkLoadRouteChildren,
  );

interface DashJerboaClientPreviewRouteChildren {
  DashJerboaClientPreviewIdRoute: typeof DashJerboaClientPreviewIdRoute;
  DashJerboaClientPreviewIndexRoute: typeof DashJerboaClientPreviewIndexRoute;
}

const DashJerboaClientPreviewRouteChildren: DashJerboaClientPreviewRouteChildren =
  {
    DashJerboaClientPreviewIdRoute: DashJerboaClientPreviewIdRoute,
    DashJerboaClientPreviewIndexRoute: DashJerboaClientPreviewIndexRoute,
  };

const DashJerboaClientPreviewRouteWithChildren =
  DashJerboaClientPreviewRoute._addFileChildren(
    DashJerboaClientPreviewRouteChildren,
  );

interface DashJerboaCodecReportRouteChildren {
  DashJerboaCodecReportIdRoute: typeof DashJerboaCodecReportIdRoute;
  DashJerboaCodecReportIndexRoute: typeof DashJerboaCodecReportIndexRoute;
}

const DashJerboaCodecReportRouteChildren: DashJerboaCodecReportRouteChildren = {
  DashJerboaCodecReportIdRoute: DashJerboaCodecReportIdRoute,
  DashJerboaCodecReportIndexRoute: DashJerboaCodecReportIndexRoute,
};

const DashJerboaCodecReportRouteWithChildren =
  DashJerboaCodecReportRoute._addFileChildren(
    DashJerboaCodecReportRouteChildren,
  );

interface DashJerboaEditorSessionRouteChildren {
  DashJerboaEditorSessionIdRoute: typeof DashJerboaEditorSessionIdRoute;
  DashJerboaEditorSessionIndexRoute: typeof DashJerboaEditorSessionIndexRoute;
}

const DashJerboaEditorSessionRouteChildren: DashJerboaEditorSessionRouteChildren =
  {
    DashJerboaEditorSessionIdRoute: DashJerboaEditorSessionIdRoute,
    DashJerboaEditorSessionIndexRoute: DashJerboaEditorSessionIndexRoute,
  };

const DashJerboaEditorSessionRouteWithChildren =
  DashJerboaEditorSessionRoute._addFileChildren(
    DashJerboaEditorSessionRouteChildren,
  );

interface DashLinkedinSkillsRouteChildren {
  DashLinkedinSkillsUsersUserIdRoute: typeof DashLinkedinSkillsUsersUserIdRoute;
}

const DashLinkedinSkillsRouteChildren: DashLinkedinSkillsRouteChildren = {
  DashLinkedinSkillsUsersUserIdRoute: DashLinkedinSkillsUsersUserIdRoute,
};

const DashLinkedinSkillsRouteWithChildren =
  DashLinkedinSkillsRoute._addFileChildren(DashLinkedinSkillsRouteChildren);

interface DashLtvRouteChildren {
  DashLtvAppsflyerSendAuditRoute: typeof DashLtvAppsflyerSendAuditRoute;
  DashLtvMetaSendAuditRoute: typeof DashLtvMetaSendAuditRoute;
}

const DashLtvRouteChildren: DashLtvRouteChildren = {
  DashLtvAppsflyerSendAuditRoute: DashLtvAppsflyerSendAuditRoute,
  DashLtvMetaSendAuditRoute: DashLtvMetaSendAuditRoute,
};

const DashLtvRouteWithChildren =
  DashLtvRoute._addFileChildren(DashLtvRouteChildren);

interface DashMcpRouteChildren {
  DashMcpIndexRoute: typeof DashMcpIndexRoute;
  DashMcpSkillsSkillRoute: typeof DashMcpSkillsSkillRoute;
}

const DashMcpRouteChildren: DashMcpRouteChildren = {
  DashMcpIndexRoute: DashMcpIndexRoute,
  DashMcpSkillsSkillRoute: DashMcpSkillsSkillRoute,
};

const DashMcpRouteWithChildren =
  DashMcpRoute._addFileChildren(DashMcpRouteChildren);

interface DashModerationRouteChildren {
  DashModerationIndexRoute: typeof DashModerationIndexRoute;
}

const DashModerationRouteChildren: DashModerationRouteChildren = {
  DashModerationIndexRoute: DashModerationIndexRoute,
};

const DashModerationRouteWithChildren = DashModerationRoute._addFileChildren(
  DashModerationRouteChildren,
);

interface DashOrganizationsRouteChildren {
  DashOrganizationsIndexRoute: typeof DashOrganizationsIndexRoute;
  DashOrganizationsViewOrgIdRoute: typeof DashOrganizationsViewOrgIdRoute;
}

const DashOrganizationsRouteChildren: DashOrganizationsRouteChildren = {
  DashOrganizationsIndexRoute: DashOrganizationsIndexRoute,
  DashOrganizationsViewOrgIdRoute: DashOrganizationsViewOrgIdRoute,
};

const DashOrganizationsRouteWithChildren =
  DashOrganizationsRoute._addFileChildren(DashOrganizationsRouteChildren);

interface DashProjectsRouteChildren {
  DashProjectsProjectIdRoute: typeof DashProjectsProjectIdRoute;
  DashProjectsAnimationLibraryRoute: typeof DashProjectsAnimationLibraryRoute;
  DashProjectsChatsRoute: typeof DashProjectsChatsRoute;
  DashProjectsSearchRoute: typeof DashProjectsSearchRoute;
  DashProjectsTesseractRoute: typeof DashProjectsTesseractRoute;
  DashProjectsIndexRoute: typeof DashProjectsIndexRoute;
}

const DashProjectsRouteChildren: DashProjectsRouteChildren = {
  DashProjectsProjectIdRoute: DashProjectsProjectIdRoute,
  DashProjectsAnimationLibraryRoute: DashProjectsAnimationLibraryRoute,
  DashProjectsChatsRoute: DashProjectsChatsRoute,
  DashProjectsSearchRoute: DashProjectsSearchRoute,
  DashProjectsTesseractRoute: DashProjectsTesseractRoute,
  DashProjectsIndexRoute: DashProjectsIndexRoute,
};

const DashProjectsRouteWithChildren = DashProjectsRoute._addFileChildren(
  DashProjectsRouteChildren,
);

interface DashSessionReplaysRouteChildren {
  DashSessionReplaysReplayIdRoute: typeof DashSessionReplaysReplayIdRoute;
  DashSessionReplaysIndexRoute: typeof DashSessionReplaysIndexRoute;
}

const DashSessionReplaysRouteChildren: DashSessionReplaysRouteChildren = {
  DashSessionReplaysReplayIdRoute: DashSessionReplaysReplayIdRoute,
  DashSessionReplaysIndexRoute: DashSessionReplaysIndexRoute,
};

const DashSessionReplaysRouteWithChildren =
  DashSessionReplaysRoute._addFileChildren(DashSessionReplaysRouteChildren);

interface DashStudioEditsRouteChildren {
  DashStudioEditsIndexRoute: typeof DashStudioEditsIndexRoute;
  DashStudioEditsViewVideoIdRoute: typeof DashStudioEditsViewVideoIdRoute;
}

const DashStudioEditsRouteChildren: DashStudioEditsRouteChildren = {
  DashStudioEditsIndexRoute: DashStudioEditsIndexRoute,
  DashStudioEditsViewVideoIdRoute: DashStudioEditsViewVideoIdRoute,
};

const DashStudioEditsRouteWithChildren = DashStudioEditsRoute._addFileChildren(
  DashStudioEditsRouteChildren,
);

interface DashUsersRouteChildren {
  DashUsersInternalAccountsRoute: typeof DashUsersInternalAccountsRoute;
  DashUsersInternalTestAccountsRoute: typeof DashUsersInternalTestAccountsRoute;
  DashUsersIndexRoute: typeof DashUsersIndexRoute;
  DashUsersDeleteAccountUserIdRoute: typeof DashUsersDeleteAccountUserIdRoute;
  DashUsersForceSignOutUserIdRoute: typeof DashUsersForceSignOutUserIdRoute;
  DashUsersUndeleteAccountUserIdRoute: typeof DashUsersUndeleteAccountUserIdRoute;
  DashUsersViewUserIdRoute: typeof DashUsersViewUserIdRoute;
}

const DashUsersRouteChildren: DashUsersRouteChildren = {
  DashUsersInternalAccountsRoute: DashUsersInternalAccountsRoute,
  DashUsersInternalTestAccountsRoute: DashUsersInternalTestAccountsRoute,
  DashUsersIndexRoute: DashUsersIndexRoute,
  DashUsersDeleteAccountUserIdRoute: DashUsersDeleteAccountUserIdRoute,
  DashUsersForceSignOutUserIdRoute: DashUsersForceSignOutUserIdRoute,
  DashUsersUndeleteAccountUserIdRoute: DashUsersUndeleteAccountUserIdRoute,
  DashUsersViewUserIdRoute: DashUsersViewUserIdRoute,
};

const DashUsersRouteWithChildren = DashUsersRoute._addFileChildren(
  DashUsersRouteChildren,
);

interface DashVideosEvalsTestIdRouteChildren {
  DashVideosEvalsTestIdRankRoute: typeof DashVideosEvalsTestIdRankRoute;
  DashVideosEvalsTestIdResultsRoute: typeof DashVideosEvalsTestIdResultsRoute;
  DashVideosEvalsTestIdIndexRoute: typeof DashVideosEvalsTestIdIndexRoute;
}

const DashVideosEvalsTestIdRouteChildren: DashVideosEvalsTestIdRouteChildren = {
  DashVideosEvalsTestIdRankRoute: DashVideosEvalsTestIdRankRoute,
  DashVideosEvalsTestIdResultsRoute: DashVideosEvalsTestIdResultsRoute,
  DashVideosEvalsTestIdIndexRoute: DashVideosEvalsTestIdIndexRoute,
};

const DashVideosEvalsTestIdRouteWithChildren =
  DashVideosEvalsTestIdRoute._addFileChildren(
    DashVideosEvalsTestIdRouteChildren,
  );

interface DashVideosEvalsRouteChildren {
  DashVideosEvalsTestIdRoute: typeof DashVideosEvalsTestIdRouteWithChildren;
  DashVideosEvalsIndexRoute: typeof DashVideosEvalsIndexRoute;
  DashVideosEvalsDpoReviewPanelIdRoute: typeof DashVideosEvalsDpoReviewPanelIdRoute;
  DashVideosEvalsDpoTestIdRoute: typeof DashVideosEvalsDpoTestIdRoute;
  DashVideosEvalsDpoReviewIndexRoute: typeof DashVideosEvalsDpoReviewIndexRoute;
  DashVideosEvalsDpoIndexRoute: typeof DashVideosEvalsDpoIndexRoute;
}

const DashVideosEvalsRouteChildren: DashVideosEvalsRouteChildren = {
  DashVideosEvalsTestIdRoute: DashVideosEvalsTestIdRouteWithChildren,
  DashVideosEvalsIndexRoute: DashVideosEvalsIndexRoute,
  DashVideosEvalsDpoReviewPanelIdRoute: DashVideosEvalsDpoReviewPanelIdRoute,
  DashVideosEvalsDpoTestIdRoute: DashVideosEvalsDpoTestIdRoute,
  DashVideosEvalsDpoReviewIndexRoute: DashVideosEvalsDpoReviewIndexRoute,
  DashVideosEvalsDpoIndexRoute: DashVideosEvalsDpoIndexRoute,
};

const DashVideosEvalsRouteWithChildren = DashVideosEvalsRoute._addFileChildren(
  DashVideosEvalsRouteChildren,
);

interface DashVideosRouteChildren {
  DashVideosBookmarkedRoute: typeof DashVideosBookmarkedRoute;
  DashVideosEvalsRoute: typeof DashVideosEvalsRouteWithChildren;
  DashVideosIndexRoute: typeof DashVideosIndexRoute;
  DashVideosSegmentEvalAdminRoute: typeof DashVideosSegmentEvalAdminRoute;
  DashVideosSegmentEvalResultsRoute: typeof DashVideosSegmentEvalResultsRoute;
  DashVideosViewVideoIdRoute: typeof DashVideosViewVideoIdRoute;
  DashVideosSegmentEvalIndexRoute: typeof DashVideosSegmentEvalIndexRoute;
}

const DashVideosRouteChildren: DashVideosRouteChildren = {
  DashVideosBookmarkedRoute: DashVideosBookmarkedRoute,
  DashVideosEvalsRoute: DashVideosEvalsRouteWithChildren,
  DashVideosIndexRoute: DashVideosIndexRoute,
  DashVideosSegmentEvalAdminRoute: DashVideosSegmentEvalAdminRoute,
  DashVideosSegmentEvalResultsRoute: DashVideosSegmentEvalResultsRoute,
  DashVideosViewVideoIdRoute: DashVideosViewVideoIdRoute,
  DashVideosSegmentEvalIndexRoute: DashVideosSegmentEvalIndexRoute,
};

const DashVideosRouteWithChildren = DashVideosRoute._addFileChildren(
  DashVideosRouteChildren,
);

interface DashRouteChildren {
  DashActorsRoute: typeof DashActorsRouteWithChildren;
  DashAgaveRoute: typeof DashAgaveRoute;
  DashAiEditToolRoute: typeof DashAiEditToolRouteWithChildren;
  DashAiEditsRoute: typeof DashAiEditsRouteWithChildren;
  DashAudioRoute: typeof DashAudioRouteWithChildren;
  DashBasecampRoute: typeof DashBasecampRouteWithChildren;
  DashBasecampRunInspectorRoute: typeof DashBasecampRunInspectorRoute;
  DashBasecampStyleReviewsRoute: typeof DashBasecampStyleReviewsRoute;
  DashBetaWaitlistRoute: typeof DashBetaWaitlistRoute;
  DashCapcodeRoute: typeof DashCapcodeRouteWithChildren;
  DashCaptionTemplatesRoute: typeof DashCaptionTemplatesRouteWithChildren;
  DashCloudflareRedirectsRoute: typeof DashCloudflareRedirectsRouteWithChildren;
  DashCreatorStylesRoute: typeof DashCreatorStylesRouteWithChildren;
  DashCreditsRoute: typeof DashCreditsRouteWithChildren;
  DashEmployeeRoute: typeof DashEmployeeRoute;
  DashFileUploadRoute: typeof DashFileUploadRoute;
  DashHomeRoute: typeof DashHomeRoute;
  DashHumanEditingRequestsRoute: typeof DashHumanEditingRequestsRoute;
  DashJerboaRoute: typeof DashJerboaRouteWithChildren;
  DashJerboaClientErrorRoute: typeof DashJerboaClientErrorRouteWithChildren;
  DashJerboaClientExportRoute: typeof DashJerboaClientExportRouteWithChildren;
  DashJerboaClientNetworkLoadRoute: typeof DashJerboaClientNetworkLoadRouteWithChildren;
  DashJerboaClientPreviewRoute: typeof DashJerboaClientPreviewRouteWithChildren;
  DashJerboaCodecReportRoute: typeof DashJerboaCodecReportRouteWithChildren;
  DashJerboaEditorSessionRoute: typeof DashJerboaEditorSessionRouteWithChildren;
  DashLinkedinSkillsRoute: typeof DashLinkedinSkillsRouteWithChildren;
  DashLtvRoute: typeof DashLtvRouteWithChildren;
  DashMcpRoute: typeof DashMcpRouteWithChildren;
  DashModerationRoute: typeof DashModerationRouteWithChildren;
  DashOrganizationsRoute: typeof DashOrganizationsRouteWithChildren;
  DashProfileRoute: typeof DashProfileRoute;
  DashProjectsRoute: typeof DashProjectsRouteWithChildren;
  DashReleaseHistoryRoute: typeof DashReleaseHistoryRoute;
  DashSessionRoute: typeof DashSessionRoute;
  DashSessionReplaysRoute: typeof DashSessionReplaysRouteWithChildren;
  DashStudioEditsRoute: typeof DashStudioEditsRouteWithChildren;
  DashUsersRoute: typeof DashUsersRouteWithChildren;
  DashVideosRoute: typeof DashVideosRouteWithChildren;
  DashYoutubeDownloadRoute: typeof DashYoutubeDownloadRoute;
  DashReviewFeedbackFeedbackIdRoute: typeof DashReviewFeedbackFeedbackIdRoute;
  DashOrgByDefaultIndexRoute: typeof DashOrgByDefaultIndexRoute;
  DashChargesOrganizationsOrgIdRoute: typeof DashChargesOrganizationsOrgIdRoute;
  DashChargesUsersUserIdRoute: typeof DashChargesUsersUserIdRoute;
}

const DashRouteChildren: DashRouteChildren = {
  DashActorsRoute: DashActorsRouteWithChildren,
  DashAgaveRoute: DashAgaveRoute,
  DashAiEditToolRoute: DashAiEditToolRouteWithChildren,
  DashAiEditsRoute: DashAiEditsRouteWithChildren,
  DashAudioRoute: DashAudioRouteWithChildren,
  DashBasecampRoute: DashBasecampRouteWithChildren,
  DashBasecampRunInspectorRoute: DashBasecampRunInspectorRoute,
  DashBasecampStyleReviewsRoute: DashBasecampStyleReviewsRoute,
  DashBetaWaitlistRoute: DashBetaWaitlistRoute,
  DashCapcodeRoute: DashCapcodeRouteWithChildren,
  DashCaptionTemplatesRoute: DashCaptionTemplatesRouteWithChildren,
  DashCloudflareRedirectsRoute: DashCloudflareRedirectsRouteWithChildren,
  DashCreatorStylesRoute: DashCreatorStylesRouteWithChildren,
  DashCreditsRoute: DashCreditsRouteWithChildren,
  DashEmployeeRoute: DashEmployeeRoute,
  DashFileUploadRoute: DashFileUploadRoute,
  DashHomeRoute: DashHomeRoute,
  DashHumanEditingRequestsRoute: DashHumanEditingRequestsRoute,
  DashJerboaRoute: DashJerboaRouteWithChildren,
  DashJerboaClientErrorRoute: DashJerboaClientErrorRouteWithChildren,
  DashJerboaClientExportRoute: DashJerboaClientExportRouteWithChildren,
  DashJerboaClientNetworkLoadRoute:
    DashJerboaClientNetworkLoadRouteWithChildren,
  DashJerboaClientPreviewRoute: DashJerboaClientPreviewRouteWithChildren,
  DashJerboaCodecReportRoute: DashJerboaCodecReportRouteWithChildren,
  DashJerboaEditorSessionRoute: DashJerboaEditorSessionRouteWithChildren,
  DashLinkedinSkillsRoute: DashLinkedinSkillsRouteWithChildren,
  DashLtvRoute: DashLtvRouteWithChildren,
  DashMcpRoute: DashMcpRouteWithChildren,
  DashModerationRoute: DashModerationRouteWithChildren,
  DashOrganizationsRoute: DashOrganizationsRouteWithChildren,
  DashProfileRoute: DashProfileRoute,
  DashProjectsRoute: DashProjectsRouteWithChildren,
  DashReleaseHistoryRoute: DashReleaseHistoryRoute,
  DashSessionRoute: DashSessionRoute,
  DashSessionReplaysRoute: DashSessionReplaysRouteWithChildren,
  DashStudioEditsRoute: DashStudioEditsRouteWithChildren,
  DashUsersRoute: DashUsersRouteWithChildren,
  DashVideosRoute: DashVideosRouteWithChildren,
  DashYoutubeDownloadRoute: DashYoutubeDownloadRoute,
  DashReviewFeedbackFeedbackIdRoute: DashReviewFeedbackFeedbackIdRoute,
  DashOrgByDefaultIndexRoute: DashOrgByDefaultIndexRoute,
  DashChargesOrganizationsOrgIdRoute: DashChargesOrganizationsOrgIdRoute,
  DashChargesUsersUserIdRoute: DashChargesUsersUserIdRoute,
};

const DashRouteWithChildren = DashRoute._addFileChildren(DashRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashRoute: DashRouteWithChildren,
  AuthCallbackRoute: AuthCallbackRoute,
  AuthCapCodeMcpRoute: AuthCapCodeMcpRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
